export default {
    "YU03":{
        "cohort":"discovery",
        "sex":"Male",
        "age":34.0,
        "age_group":"<50.0 (25%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-A",
        "stage_coding":"else",
        "Biopsy_site_tissue":"LN",
        "Progression-free survival event":"Y",
        "PFS_days":33.0,
        "PFS_days_clipped2000":33.0,
        "Progression-free survival days":"<102 days (25%)",
        "response":"NR",
        "FFPE Sample Type":"punch",
        "Study_Site":"YALE",
        "ICI_cluster":"ICI-sensitive",
        "TERT":"wildtype",
        "BRAF":"wildtype",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "ARID2":"wildtype"
    },
    "MA01":{
        "cohort":"discovery",
        "sex":"Female",
        "age":78.0,
        "age_group":">68.0 (>75%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-C",
        "stage_coding":"AJCC IV C & D",
        "Biopsy_site_tissue":"skin",
        "Progression-free survival event":"Y",
        "PFS_days":40.0,
        "PFS_days_clipped2000":40.0,
        "Progression-free survival days":"<102 days (25%)",
        "response":"NR",
        "FFPE Sample Type":"slides",
        "Study_Site":"MIA",
        "ICI_cluster":"ICI-sensitive",
        "TERT":"mutant",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "ARID2":"wildtype"
    },
    "MA02":{
        "cohort":"discovery",
        "sex":"Female",
        "age":42.0,
        "age_group":"<50.0 (25%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-C",
        "stage_coding":"AJCC IV C & D",
        "Biopsy_site_tissue":"skin",
        "Progression-free survival event":"Y",
        "PFS_days":283.0,
        "PFS_days_clipped2000":283.0,
        "Progression-free survival days":"102-293 days (25%-50%)",
        "response":"R",
        "FFPE Sample Type":"gross dissection",
        "Study_Site":"MIA",
        "ICI_cluster":"Ribo-high",
        "TERT":null,
        "BRAF":null,
        "NRAS":null,
        "NF1":null,
        "ARID2":null
    },
    "YU11":{
        "cohort":"discovery",
        "sex":"Male",
        "age":86.0,
        "age_group":">68.0 (>75%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC III (includes B/C/D)",
        "stage_coding":"else",
        "Biopsy_site_tissue":"skin",
        "Progression-free survival event":"Y",
        "PFS_days":232.0,
        "PFS_days_clipped2000":232.0,
        "Progression-free survival days":"102-293 days (25%-50%)",
        "response":"R",
        "FFPE Sample Type":"punch",
        "Study_Site":"YALE",
        "ICI_cluster":"Ribo-high",
        "TERT":"mutant",
        "BRAF":"wildtype",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "ARID2":"wildtype"
    },
    "VU06":{
        "cohort":"discovery",
        "sex":"Female",
        "age":51.0,
        "age_group":"50.0-58.0 (25%-50%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-B",
        "stage_coding":"else",
        "Biopsy_site_tissue":"lung",
        "Progression-free survival event":"Y",
        "PFS_days":1010.0,
        "PFS_days_clipped2000":1010.0,
        "Progression-free survival days":"293-1604 days (50%-75%)",
        "response":"R",
        "FFPE Sample Type":"gross dissection",
        "Study_Site":"VAND",
        "ICI_cluster":"Ribo-high",
        "TERT":"wildtype",
        "BRAF":"wildtype",
        "NRAS":"mutant",
        "NF1":"wildtype",
        "ARID2":"wildtype"
    },
    "YU12":{
        "cohort":"discovery",
        "sex":"Male",
        "age":53.0,
        "age_group":"50.0-58.0 (25%-50%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC III (includes B/C/D)",
        "stage_coding":"else",
        "Biopsy_site_tissue":"LN",
        "Progression-free survival event":"Y",
        "PFS_days":213.0,
        "PFS_days_clipped2000":213.0,
        "Progression-free survival days":"102-293 days (25%-50%)",
        "response":"R",
        "FFPE Sample Type":"punch",
        "Study_Site":"YALE",
        "ICI_cluster":"Ribo-high",
        "TERT":"mutant",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"mutant",
        "ARID2":"wildtype"
    },
    "YU06":{
        "cohort":"discovery",
        "sex":"Male",
        "age":62.0,
        "age_group":"58.0-68.0 (50%-75%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC III (includes B/C/D)",
        "stage_coding":"else",
        "Biopsy_site_tissue":"LN",
        "Progression-free survival event":"Y",
        "PFS_days":1216.0,
        "PFS_days_clipped2000":1216.0,
        "Progression-free survival days":"293-1604 days (50%-75%)",
        "response":"R",
        "FFPE Sample Type":"punch",
        "Study_Site":"YALE",
        "ICI_cluster":"ICI-sensitive",
        "TERT":"mutant",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "ARID2":"wildtype"
    },
    "PN01":{
        "cohort":"discovery",
        "sex":"Male",
        "age":53.0,
        "age_group":"50.0-58.0 (25%-50%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-D",
        "stage_coding":"AJCC IV C & D",
        "Biopsy_site_tissue":"skin",
        "Progression-free survival event":"N",
        "PFS_days":2345.0,
        "PFS_days_clipped2000":2001.0,
        "Progression-free survival days":">1604 days (>75%)",
        "response":"R",
        "FFPE Sample Type":"slides",
        "Study_Site":"UPENN",
        "ICI_cluster":"Ribo-high",
        "TERT":"wildtype",
        "BRAF":"wildtype",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "ARID2":"wildtype"
    },
    "MD02":{
        "cohort":"discovery",
        "sex":"Male",
        "age":75.8083504449,
        "age_group":">68.0 (>75%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC III (includes B/C/D)",
        "stage_coding":"else",
        "Biopsy_site_tissue":"skin",
        "Progression-free survival event":"Y",
        "PFS_days":126.0,
        "PFS_days_clipped2000":126.0,
        "Progression-free survival days":"102-293 days (25%-50%)",
        "response":"NR",
        "FFPE Sample Type":"slides",
        "Study_Site":"MDACC",
        "ICI_cluster":"Ribo-high",
        "TERT":"mutant",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "ARID2":"wildtype"
    },
    "PT05":{
        "cohort":"discovery",
        "sex":"Female",
        "age":32.0,
        "age_group":"<50.0 (25%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-B",
        "stage_coding":"else",
        "Biopsy_site_tissue":"lung",
        "Progression-free survival event":"N",
        "PFS_days":2240.0,
        "PFS_days_clipped2000":2001.0,
        "Progression-free survival days":">1604 days (>75%)",
        "response":"R",
        "FFPE Sample Type":"slides",
        "Study_Site":"UPITT",
        "ICI_cluster":"ICI-sensitive",
        "TERT":"mutant",
        "BRAF":"wildtype",
        "NRAS":"mutant",
        "NF1":"wildtype",
        "ARID2":"mutant"
    },
    "PN05":{
        "cohort":"discovery",
        "sex":"Male",
        "age":60.0,
        "age_group":"58.0-68.0 (50%-75%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-C",
        "stage_coding":"AJCC IV C & D",
        "Biopsy_site_tissue":"LN",
        "Progression-free survival event":"N",
        "PFS_days":2479.0,
        "PFS_days_clipped2000":2001.0,
        "Progression-free survival days":">1604 days (>75%)",
        "response":"R",
        "FFPE Sample Type":"slides",
        "Study_Site":"UPENN",
        "ICI_cluster":"ICI-sensitive",
        "TERT":"mutant",
        "BRAF":"wildtype",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "ARID2":"mutant"
    },
    "MG07":{
        "cohort":"discovery",
        "sex":"Male",
        "age":51.0,
        "age_group":"50.0-58.0 (25%-50%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-D",
        "stage_coding":"AJCC IV C & D",
        "Biopsy_site_tissue":"LN",
        "Progression-free survival event":"Y",
        "PFS_days":47.0,
        "PFS_days_clipped2000":47.0,
        "Progression-free survival days":"<102 days (25%)",
        "response":"NR",
        "FFPE Sample Type":"slides",
        "Study_Site":"MGH",
        "ICI_cluster":"ICI-sensitive",
        "TERT":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "ARID2":"wildtype"
    },
    "PT03":{
        "cohort":"discovery",
        "sex":"Female",
        "age":55.0,
        "age_group":"50.0-58.0 (25%-50%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-A",
        "stage_coding":"else",
        "Biopsy_site_tissue":"skin",
        "Progression-free survival event":"N",
        "PFS_days":964.0,
        "PFS_days_clipped2000":964.0,
        "Progression-free survival days":"293-1604 days (50%-75%)",
        "response":"R",
        "FFPE Sample Type":"slides",
        "Study_Site":"UPITT",
        "ICI_cluster":"Ribo-high",
        "TERT":"mutant",
        "BRAF":"wildtype",
        "NRAS":"wildtype",
        "NF1":"mutant",
        "ARID2":"wildtype"
    },
    "PT07":{
        "cohort":"discovery",
        "sex":"Female",
        "age":62.0,
        "age_group":"58.0-68.0 (50%-75%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-D",
        "stage_coding":"AJCC IV C & D",
        "Biopsy_site_tissue":"LN",
        "Progression-free survival event":"N",
        "PFS_days":822.0,
        "PFS_days_clipped2000":822.0,
        "Progression-free survival days":"293-1604 days (50%-75%)",
        "response":"R",
        "FFPE Sample Type":"slides",
        "Study_Site":"UPITT",
        "ICI_cluster":"ICI-sensitive",
        "TERT":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "ARID2":"wildtype"
    },
    "YU19":{
        "cohort":"discovery",
        "sex":"Female",
        "age":70.0,
        "age_group":">68.0 (>75%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-A",
        "stage_coding":"else",
        "Biopsy_site_tissue":"LN",
        "Progression-free survival event":"N",
        "PFS_days":4200.0,
        "PFS_days_clipped2000":2001.0,
        "Progression-free survival days":">1604 days (>75%)",
        "response":"R",
        "FFPE Sample Type":"slides",
        "Study_Site":"YALE",
        "ICI_cluster":"ICI-sensitive",
        "TERT":"mutant",
        "BRAF":"wildtype",
        "NRAS":"mutant",
        "NF1":"mutant",
        "ARID2":"wildtype"
    },
    "MD01":{
        "cohort":"discovery",
        "sex":"Female",
        "age":72.2381930185,
        "age_group":">68.0 (>75%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-D",
        "stage_coding":"AJCC IV C & D",
        "Biopsy_site_tissue":"skin",
        "Progression-free survival event":"Y",
        "PFS_days":1467.0,
        "PFS_days_clipped2000":1467.0,
        "Progression-free survival days":"293-1604 days (50%-75%)",
        "response":"R",
        "FFPE Sample Type":"gross dissection",
        "Study_Site":"MDACC",
        "ICI_cluster":"ICI-sensitive",
        "TERT":null,
        "BRAF":null,
        "NRAS":null,
        "NF1":null,
        "ARID2":null
    },
    "YU18":{
        "cohort":"discovery",
        "sex":"Male",
        "age":51.0,
        "age_group":"50.0-58.0 (25%-50%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC III (includes B/C/D)",
        "stage_coding":"else",
        "Biopsy_site_tissue":"skin",
        "Progression-free survival event":"N",
        "PFS_days":1775.0,
        "PFS_days_clipped2000":1775.0,
        "Progression-free survival days":">1604 days (>75%)",
        "response":"R",
        "FFPE Sample Type":"slides",
        "Study_Site":"YALE",
        "ICI_cluster":"Ribo-high",
        "TERT":"mutant",
        "BRAF":"wildtype",
        "NRAS":"mutant",
        "NF1":"mutant",
        "ARID2":"wildtype"
    },
    "MA17":{
        "cohort":"discovery",
        "sex":"Female",
        "age":37.0,
        "age_group":"<50.0 (25%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-C",
        "stage_coding":"AJCC IV C & D",
        "Biopsy_site_tissue":"LN",
        "Progression-free survival event":"Y",
        "PFS_days":959.0,
        "PFS_days_clipped2000":959.0,
        "Progression-free survival days":"293-1604 days (50%-75%)",
        "response":"R",
        "FFPE Sample Type":"slides",
        "Study_Site":"MIA",
        "ICI_cluster":"ICI-sensitive",
        "TERT":"mutant",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "ARID2":"wildtype"
    },
    "VU09":{
        "cohort":"discovery",
        "sex":"Male",
        "age":51.0,
        "age_group":"50.0-58.0 (25%-50%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-D",
        "stage_coding":"AJCC IV C & D",
        "Biopsy_site_tissue":"skin",
        "Progression-free survival event":"N",
        "PFS_days":1099.0,
        "PFS_days_clipped2000":1099.0,
        "Progression-free survival days":"293-1604 days (50%-75%)",
        "response":"R",
        "FFPE Sample Type":"gross dissection",
        "Study_Site":"VAND",
        "ICI_cluster":"Ribo-high",
        "TERT":"mutant",
        "BRAF":"wildtype",
        "NRAS":"mutant",
        "NF1":"mutant",
        "ARID2":"wildtype"
    },
    "YU01":{
        "cohort":"discovery",
        "sex":"Female",
        "age":58.0,
        "age_group":"58.0-68.0 (50%-75%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-A",
        "stage_coding":"else",
        "Biopsy_site_tissue":"skin",
        "Progression-free survival event":"Y",
        "PFS_days":80.0,
        "PFS_days_clipped2000":80.0,
        "Progression-free survival days":"<102 days (25%)",
        "response":"NR",
        "FFPE Sample Type":"punch",
        "Study_Site":"YALE",
        "ICI_cluster":"Ribo-high",
        "TERT":"mutant",
        "BRAF":"wildtype",
        "NRAS":"wildtype",
        "NF1":"mutant",
        "ARID2":"wildtype"
    },
    "MA16":{
        "cohort":"discovery",
        "sex":"Female",
        "age":46.0,
        "age_group":"<50.0 (25%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-D",
        "stage_coding":"AJCC IV C & D",
        "Biopsy_site_tissue":"lung",
        "Progression-free survival event":"N",
        "PFS_days":2015.0,
        "PFS_days_clipped2000":2001.0,
        "Progression-free survival days":">1604 days (>75%)",
        "response":"R",
        "FFPE Sample Type":"slides",
        "Study_Site":"MIA",
        "ICI_cluster":"Ribo-high",
        "TERT":"mutant",
        "BRAF":"mutant",
        "NRAS":"mutant",
        "NF1":"wildtype",
        "ARID2":"wildtype"
    },
    "YU17":{
        "cohort":"discovery",
        "sex":"Male",
        "age":84.0,
        "age_group":">68.0 (>75%)",
        "ethnicity":"non-Caucasian",
        "AJCC Stage":"AJCC III (includes B/C/D)",
        "stage_coding":"else",
        "Biopsy_site_tissue":"LN",
        "Progression-free survival event":"Y",
        "PFS_days":83.0,
        "PFS_days_clipped2000":83.0,
        "Progression-free survival days":"<102 days (25%)",
        "response":"NR",
        "FFPE Sample Type":"slides",
        "Study_Site":"YALE",
        "ICI_cluster":"Ribo-high",
        "TERT":"mutant",
        "BRAF":"wildtype",
        "NRAS":"mutant",
        "NF1":"wildtype",
        "ARID2":"mutant"
    },
    "YU24":{
        "cohort":"discovery",
        "sex":"Male",
        "age":58.0,
        "age_group":"58.0-68.0 (50%-75%)",
        "ethnicity":"Hispanic",
        "AJCC Stage":"AJCC III (includes B/C/D)",
        "stage_coding":"else",
        "Biopsy_site_tissue":"LN",
        "Progression-free survival event":"Y",
        "PFS_days":47.0,
        "PFS_days_clipped2000":47.0,
        "Progression-free survival days":"<102 days (25%)",
        "response":"NR",
        "FFPE Sample Type":"punch",
        "Study_Site":"YALE",
        "ICI_cluster":"EMT-like",
        "TERT":"mutant",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "ARID2":"mutant"
    },
    "PN08":{
        "cohort":"discovery",
        "sex":"Male",
        "age":65.0,
        "age_group":"58.0-68.0 (50%-75%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-C",
        "stage_coding":"AJCC IV C & D",
        "Biopsy_site_tissue":"skin",
        "Progression-free survival event":"N",
        "PFS_days":196.0,
        "PFS_days_clipped2000":196.0,
        "Progression-free survival days":"102-293 days (25%-50%)",
        "response":"R",
        "FFPE Sample Type":"gross dissection",
        "Study_Site":"UPENN",
        "ICI_cluster":"Ribo-high",
        "TERT":null,
        "BRAF":null,
        "NRAS":null,
        "NF1":null,
        "ARID2":null
    },
    "PT10":{
        "cohort":"discovery",
        "sex":"Male",
        "age":61.0,
        "age_group":"58.0-68.0 (50%-75%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-C",
        "stage_coding":"AJCC IV C & D",
        "Biopsy_site_tissue":"skin",
        "Progression-free survival event":"N",
        "PFS_days":605.0,
        "PFS_days_clipped2000":605.0,
        "Progression-free survival days":"293-1604 days (50%-75%)",
        "response":"R",
        "FFPE Sample Type":"slides",
        "Study_Site":"UPITT",
        "ICI_cluster":"Ribo-high",
        "TERT":"mutant",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "ARID2":"wildtype"
    },
    "VU11":{
        "cohort":"discovery",
        "sex":"Female",
        "age":65.0,
        "age_group":"58.0-68.0 (50%-75%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-B",
        "stage_coding":"else",
        "Biopsy_site_tissue":"LN",
        "Progression-free survival event":"Y",
        "PFS_days":126.0,
        "PFS_days_clipped2000":126.0,
        "Progression-free survival days":"102-293 days (25%-50%)",
        "response":"NR",
        "FFPE Sample Type":"slides",
        "Study_Site":"VAND",
        "ICI_cluster":"ICI-sensitive",
        "TERT":"mutant",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "ARID2":"wildtype"
    },
    "YU21":{
        "cohort":"discovery",
        "sex":"Female",
        "age":52.0,
        "age_group":"50.0-58.0 (25%-50%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC III (includes B/C/D)",
        "stage_coding":"else",
        "Biopsy_site_tissue":"LN",
        "Progression-free survival event":"Y",
        "PFS_days":397.0,
        "PFS_days_clipped2000":397.0,
        "Progression-free survival days":"293-1604 days (50%-75%)",
        "response":"R",
        "FFPE Sample Type":"punch",
        "Study_Site":"YALE",
        "ICI_cluster":"Ribo-high",
        "TERT":"mutant",
        "BRAF":"wildtype",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "ARID2":"mutant"
    },
    "YU02":{
        "cohort":"discovery",
        "sex":"Male",
        "age":46.0,
        "age_group":"<50.0 (25%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC III (includes B/C/D)",
        "stage_coding":"else",
        "Biopsy_site_tissue":"LN",
        "Progression-free survival event":"Y",
        "PFS_days":194.0,
        "PFS_days_clipped2000":194.0,
        "Progression-free survival days":"102-293 days (25%-50%)",
        "response":"R",
        "FFPE Sample Type":"punch",
        "Study_Site":"YALE",
        "ICI_cluster":"EMT-like",
        "TERT":null,
        "BRAF":null,
        "NRAS":null,
        "NF1":null,
        "ARID2":null
    },
    "PT01":{
        "cohort":"discovery",
        "sex":"Male",
        "age":60.0,
        "age_group":"58.0-68.0 (50%-75%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-A",
        "stage_coding":"else",
        "Biopsy_site_tissue":"skin",
        "Progression-free survival event":"N",
        "PFS_days":2159.0,
        "PFS_days_clipped2000":2001.0,
        "Progression-free survival days":">1604 days (>75%)",
        "response":"R",
        "FFPE Sample Type":"slides",
        "Study_Site":"UPITT",
        "ICI_cluster":"EMT-like",
        "TERT":"mutant",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "ARID2":"wildtype"
    },
    "YU13":{
        "cohort":"discovery",
        "sex":"Male",
        "age":52.0,
        "age_group":"50.0-58.0 (25%-50%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-A",
        "stage_coding":"else",
        "Biopsy_site_tissue":"skin",
        "Progression-free survival event":"N",
        "PFS_days":4663.0,
        "PFS_days_clipped2000":2001.0,
        "Progression-free survival days":">1604 days (>75%)",
        "response":"R",
        "FFPE Sample Type":"punch",
        "Study_Site":"YALE",
        "ICI_cluster":"Ribo-high",
        "TERT":"mutant",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "ARID2":"wildtype"
    },
    "MG02":{
        "cohort":"discovery",
        "sex":"Male",
        "age":71.0,
        "age_group":">68.0 (>75%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-C",
        "stage_coding":"AJCC IV C & D",
        "Biopsy_site_tissue":"skin",
        "Progression-free survival event":"N",
        "PFS_days":2923.0,
        "PFS_days_clipped2000":2001.0,
        "Progression-free survival days":">1604 days (>75%)",
        "response":"R",
        "FFPE Sample Type":"slides",
        "Study_Site":"MGH",
        "ICI_cluster":"EMT-like",
        "TERT":"mutant",
        "BRAF":"wildtype",
        "NRAS":"wildtype",
        "NF1":"mutant",
        "ARID2":"wildtype"
    },
    "MA14":{
        "cohort":"discovery",
        "sex":"Male",
        "age":29.0,
        "age_group":"<50.0 (25%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-D",
        "stage_coding":"AJCC IV C & D",
        "Biopsy_site_tissue":"skin",
        "Progression-free survival event":"Y",
        "PFS_days":167.0,
        "PFS_days_clipped2000":167.0,
        "Progression-free survival days":"102-293 days (25%-50%)",
        "response":"NR",
        "FFPE Sample Type":"slides",
        "Study_Site":"MIA",
        "ICI_cluster":"Ribo-high",
        "TERT":"mutant",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "ARID2":"wildtype"
    },
    "PT08":{
        "cohort":"discovery",
        "sex":"Female",
        "age":52.0,
        "age_group":"50.0-58.0 (25%-50%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-B",
        "stage_coding":"else",
        "Biopsy_site_tissue":"skin",
        "Progression-free survival event":"Y",
        "PFS_days":78.0,
        "PFS_days_clipped2000":78.0,
        "Progression-free survival days":"<102 days (25%)",
        "response":"NR",
        "FFPE Sample Type":"slides",
        "Study_Site":"UPITT",
        "ICI_cluster":"ICI-sensitive",
        "TERT":"wildtype",
        "BRAF":"mutant",
        "NRAS":"mutant",
        "NF1":"wildtype",
        "ARID2":"wildtype"
    },
    "MA03":{
        "cohort":"discovery",
        "sex":"Male",
        "age":81.0,
        "age_group":">68.0 (>75%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-B",
        "stage_coding":"else",
        "Biopsy_site_tissue":"lung",
        "Progression-free survival event":"Y",
        "PFS_days":1139.0,
        "PFS_days_clipped2000":1139.0,
        "Progression-free survival days":"293-1604 days (50%-75%)",
        "response":"R",
        "FFPE Sample Type":"slides",
        "Study_Site":"MIA",
        "ICI_cluster":"Ribo-high",
        "TERT":"wildtype",
        "BRAF":"wildtype",
        "NRAS":"mutant",
        "NF1":"wildtype",
        "ARID2":"wildtype"
    },
    "PN02":{
        "cohort":"discovery",
        "sex":"Male",
        "age":65.0,
        "age_group":"58.0-68.0 (50%-75%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-B",
        "stage_coding":"else",
        "Biopsy_site_tissue":"lung",
        "Progression-free survival event":"N",
        "PFS_days":2455.0,
        "PFS_days_clipped2000":2001.0,
        "Progression-free survival days":">1604 days (>75%)",
        "response":"R",
        "FFPE Sample Type":"gross dissection",
        "Study_Site":"UPENN",
        "ICI_cluster":"ICI-sensitive",
        "TERT":null,
        "BRAF":null,
        "NRAS":null,
        "NF1":null,
        "ARID2":null
    },
    "MA04":{
        "cohort":"discovery",
        "sex":"Male",
        "age":49.0,
        "age_group":"<50.0 (25%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-B",
        "stage_coding":"else",
        "Biopsy_site_tissue":"lung",
        "Progression-free survival event":"N",
        "PFS_days":3171.0,
        "PFS_days_clipped2000":2001.0,
        "Progression-free survival days":">1604 days (>75%)",
        "response":"R",
        "FFPE Sample Type":"slides",
        "Study_Site":"MIA",
        "ICI_cluster":"EMT-like",
        "TERT":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"mutant",
        "ARID2":"wildtype"
    },
    "MD07":{
        "cohort":"discovery",
        "sex":"Male",
        "age":52.6543463381,
        "age_group":"50.0-58.0 (25%-50%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-D",
        "stage_coding":"AJCC IV C & D",
        "Biopsy_site_tissue":"skin",
        "Progression-free survival event":"Y",
        "PFS_days":414.0,
        "PFS_days_clipped2000":414.0,
        "Progression-free survival days":"293-1604 days (50%-75%)",
        "response":"R",
        "FFPE Sample Type":"gross dissection",
        "Study_Site":"MDACC",
        "ICI_cluster":"Ribo-high",
        "TERT":null,
        "BRAF":null,
        "NRAS":null,
        "NF1":null,
        "ARID2":null
    },
    "MD03":{
        "cohort":"discovery",
        "sex":"Male",
        "age":71.9288158795,
        "age_group":">68.0 (>75%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-C",
        "stage_coding":"AJCC IV C & D",
        "Biopsy_site_tissue":"LN",
        "Progression-free survival event":"Y",
        "PFS_days":83.0,
        "PFS_days_clipped2000":83.0,
        "Progression-free survival days":"<102 days (25%)",
        "response":"NR",
        "FFPE Sample Type":"slides",
        "Study_Site":"MDACC",
        "ICI_cluster":"Ribo-high",
        "TERT":"mutant",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"mutant",
        "ARID2":"mutant"
    },
    "PT06":{
        "cohort":"discovery",
        "sex":"Female",
        "age":69.0,
        "age_group":">68.0 (>75%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-B",
        "stage_coding":"else",
        "Biopsy_site_tissue":"skin",
        "Progression-free survival event":"N",
        "PFS_days":2217.0,
        "PFS_days_clipped2000":2001.0,
        "Progression-free survival days":">1604 days (>75%)",
        "response":"R",
        "FFPE Sample Type":"slides",
        "Study_Site":"UPITT",
        "ICI_cluster":"Ribo-high",
        "TERT":"mutant",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "ARID2":"wildtype"
    },
    "YU04":{
        "cohort":"discovery",
        "sex":"Male",
        "age":82.0,
        "age_group":">68.0 (>75%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC III (includes B/C/D)",
        "stage_coding":"else",
        "Biopsy_site_tissue":"skin",
        "Progression-free survival event":"N",
        "PFS_days":1567.0,
        "PFS_days_clipped2000":1567.0,
        "Progression-free survival days":"293-1604 days (50%-75%)",
        "response":"R",
        "FFPE Sample Type":"slides",
        "Study_Site":"YALE",
        "ICI_cluster":"ICI-sensitive",
        "TERT":null,
        "BRAF":null,
        "NRAS":null,
        "NF1":null,
        "ARID2":null
    },
    "MG03":{
        "cohort":"discovery",
        "sex":"Male",
        "age":48.0,
        "age_group":"<50.0 (25%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-C",
        "stage_coding":"AJCC IV C & D",
        "Biopsy_site_tissue":"skin",
        "Progression-free survival event":"Y",
        "PFS_days":22.0,
        "PFS_days_clipped2000":22.0,
        "Progression-free survival days":"<102 days (25%)",
        "response":"NR",
        "FFPE Sample Type":"slides",
        "Study_Site":"MGH",
        "ICI_cluster":"ICI-sensitive",
        "TERT":"wildtype",
        "BRAF":"wildtype",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "ARID2":"wildtype"
    },
    "YU07":{
        "cohort":"discovery",
        "sex":"Male",
        "age":68.0,
        "age_group":">68.0 (>75%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-A",
        "stage_coding":"else",
        "Biopsy_site_tissue":"LN",
        "Progression-free survival event":"Y",
        "PFS_days":331.0,
        "PFS_days_clipped2000":331.0,
        "Progression-free survival days":"293-1604 days (50%-75%)",
        "response":"R",
        "FFPE Sample Type":"punch",
        "Study_Site":"YALE",
        "ICI_cluster":"Ribo-high",
        "TERT":null,
        "BRAF":null,
        "NRAS":null,
        "NF1":null,
        "ARID2":null
    },
    "VU07":{
        "cohort":"discovery",
        "sex":"Male",
        "age":61.0,
        "age_group":"58.0-68.0 (50%-75%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-C",
        "stage_coding":"AJCC IV C & D",
        "Biopsy_site_tissue":"skin",
        "Progression-free survival event":"N",
        "PFS_days":882.0,
        "PFS_days_clipped2000":882.0,
        "Progression-free survival days":"293-1604 days (50%-75%)",
        "response":"R",
        "FFPE Sample Type":"slides",
        "Study_Site":"VAND",
        "ICI_cluster":"ICI-sensitive",
        "TERT":"mutant",
        "BRAF":"wildtype",
        "NRAS":"mutant",
        "NF1":"wildtype",
        "ARID2":"wildtype"
    },
    "YU26":{
        "cohort":"discovery",
        "sex":"Female",
        "age":86.0,
        "age_group":">68.0 (>75%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-A",
        "stage_coding":"else",
        "Biopsy_site_tissue":"LN",
        "Progression-free survival event":"Y",
        "PFS_days":120.0,
        "PFS_days_clipped2000":120.0,
        "Progression-free survival days":"102-293 days (25%-50%)",
        "response":"NR",
        "FFPE Sample Type":"slides",
        "Study_Site":"YALE",
        "ICI_cluster":"ICI-sensitive",
        "TERT":"wildtype",
        "BRAF":"wildtype",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "ARID2":"wildtype"
    },
    "PT09":{
        "cohort":"discovery",
        "sex":"Male",
        "age":61.0,
        "age_group":"58.0-68.0 (50%-75%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-C",
        "stage_coding":"AJCC IV C & D",
        "Biopsy_site_tissue":"LN",
        "Progression-free survival event":"Y",
        "PFS_days":88.0,
        "PFS_days_clipped2000":88.0,
        "Progression-free survival days":"<102 days (25%)",
        "response":"NR",
        "FFPE Sample Type":"slides",
        "Study_Site":"UPITT",
        "ICI_cluster":"Ribo-high",
        "TERT":"mutant",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "ARID2":"wildtype"
    },
    "PN07":{
        "cohort":"discovery",
        "sex":"Male",
        "age":63.0,
        "age_group":"58.0-68.0 (50%-75%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-C",
        "stage_coding":"AJCC IV C & D",
        "Biopsy_site_tissue":"skin",
        "Progression-free survival event":"N",
        "PFS_days":717.0,
        "PFS_days_clipped2000":717.0,
        "Progression-free survival days":"293-1604 days (50%-75%)",
        "response":"R",
        "FFPE Sample Type":"slides",
        "Study_Site":"UPENN",
        "ICI_cluster":"Ribo-high",
        "TERT":null,
        "BRAF":null,
        "NRAS":null,
        "NF1":null,
        "ARID2":null
    },
    "YU16":{
        "cohort":"discovery",
        "sex":"Female",
        "age":48.0,
        "age_group":"<50.0 (25%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-A",
        "stage_coding":"else",
        "Biopsy_site_tissue":"skin",
        "Progression-free survival event":"Y",
        "PFS_days":50.0,
        "PFS_days_clipped2000":50.0,
        "Progression-free survival days":"<102 days (25%)",
        "response":"NR",
        "FFPE Sample Type":"slides",
        "Study_Site":"YALE",
        "ICI_cluster":"Ribo-high",
        "TERT":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "ARID2":"wildtype"
    },
    "VU05":{
        "cohort":"discovery",
        "sex":"Female",
        "age":50.0,
        "age_group":"50.0-58.0 (25%-50%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC III (includes B/C/D)",
        "stage_coding":"else",
        "Biopsy_site_tissue":"LN",
        "Progression-free survival event":"Y",
        "PFS_days":2600.0,
        "PFS_days_clipped2000":2001.0,
        "Progression-free survival days":">1604 days (>75%)",
        "response":"R",
        "FFPE Sample Type":"slides",
        "Study_Site":"VAND",
        "ICI_cluster":"Ribo-high",
        "TERT":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "ARID2":"wildtype"
    },
    "PN04":{
        "cohort":"discovery",
        "sex":"Male",
        "age":63.0,
        "age_group":"58.0-68.0 (50%-75%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-B",
        "stage_coding":"else",
        "Biopsy_site_tissue":"LN",
        "Progression-free survival event":"N",
        "PFS_days":1669.0,
        "PFS_days_clipped2000":1669.0,
        "Progression-free survival days":">1604 days (>75%)",
        "response":"R",
        "FFPE Sample Type":"gross dissection",
        "Study_Site":"UPENN",
        "ICI_cluster":"ICI-sensitive",
        "TERT":"mutant",
        "BRAF":"wildtype",
        "NRAS":"mutant",
        "NF1":"mutant",
        "ARID2":"wildtype"
    },
    "MA09":{
        "cohort":"discovery",
        "sex":"Female",
        "age":49.0,
        "age_group":"<50.0 (25%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-A",
        "stage_coding":"else",
        "Biopsy_site_tissue":"skin",
        "Progression-free survival event":"Y",
        "PFS_days":207.0,
        "PFS_days_clipped2000":207.0,
        "Progression-free survival days":"102-293 days (25%-50%)",
        "response":"R",
        "FFPE Sample Type":"slides",
        "Study_Site":"MIA",
        "ICI_cluster":"Ribo-high",
        "TERT":"mutant",
        "BRAF":"wildtype",
        "NRAS":"mutant",
        "NF1":"wildtype",
        "ARID2":"mutant"
    },
    "VU01":{
        "cohort":"discovery",
        "sex":"Male",
        "age":58.0,
        "age_group":"58.0-68.0 (50%-75%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-B",
        "stage_coding":"else",
        "Biopsy_site_tissue":"lung",
        "Progression-free survival event":"Y",
        "PFS_days":463.0,
        "PFS_days_clipped2000":463.0,
        "Progression-free survival days":"293-1604 days (50%-75%)",
        "response":"R",
        "FFPE Sample Type":"gross dissection",
        "Study_Site":"VAND",
        "ICI_cluster":"ICI-sensitive",
        "TERT":"mutant",
        "BRAF":"wildtype",
        "NRAS":"mutant",
        "NF1":"wildtype",
        "ARID2":"wildtype"
    },
    "MA15":{
        "cohort":"discovery",
        "sex":"Male",
        "age":57.0,
        "age_group":"50.0-58.0 (25%-50%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-C",
        "stage_coding":"AJCC IV C & D",
        "Biopsy_site_tissue":"skin",
        "Progression-free survival event":"Y",
        "PFS_days":39.0,
        "PFS_days_clipped2000":39.0,
        "Progression-free survival days":"<102 days (25%)",
        "response":"NR",
        "FFPE Sample Type":"slides",
        "Study_Site":"MIA",
        "ICI_cluster":"Ribo-high",
        "TERT":"mutant",
        "BRAF":"wildtype",
        "NRAS":"mutant",
        "NF1":"wildtype",
        "ARID2":"wildtype"
    },
    "YU20":{
        "cohort":"discovery",
        "sex":"Male",
        "age":77.0,
        "age_group":">68.0 (>75%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC III (includes B/C/D)",
        "stage_coding":"else",
        "Biopsy_site_tissue":"LN",
        "Progression-free survival event":"Y",
        "PFS_days":136.0,
        "PFS_days_clipped2000":136.0,
        "Progression-free survival days":"102-293 days (25%-50%)",
        "response":"NR",
        "FFPE Sample Type":"slides",
        "Study_Site":"YALE",
        "ICI_cluster":"Ribo-high",
        "TERT":"wildtype",
        "BRAF":"wildtype",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "ARID2":"wildtype"
    },
    "PT11":{
        "cohort":"discovery",
        "sex":"Male",
        "age":42.0,
        "age_group":"<50.0 (25%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-C",
        "stage_coding":"AJCC IV C & D",
        "Biopsy_site_tissue":"skin",
        "Progression-free survival event":"N",
        "PFS_days":480.0,
        "PFS_days_clipped2000":480.0,
        "Progression-free survival days":"293-1604 days (50%-75%)",
        "response":"R",
        "FFPE Sample Type":"slides",
        "Study_Site":"UPITT",
        "ICI_cluster":"ICI-sensitive",
        "TERT":null,
        "BRAF":null,
        "NRAS":null,
        "NF1":null,
        "ARID2":null
    },
    "MG10":{
        "cohort":"discovery",
        "sex":"Male",
        "age":44.0,
        "age_group":"<50.0 (25%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-C",
        "stage_coding":"AJCC IV C & D",
        "Biopsy_site_tissue":"skin",
        "Progression-free survival event":"N",
        "PFS_days":2716.0,
        "PFS_days_clipped2000":2001.0,
        "Progression-free survival days":">1604 days (>75%)",
        "response":"R",
        "FFPE Sample Type":"slides",
        "Study_Site":"MGH",
        "ICI_cluster":"Ribo-high",
        "TERT":null,
        "BRAF":null,
        "NRAS":null,
        "NF1":null,
        "ARID2":null
    },
    "MA18":{
        "cohort":"discovery",
        "sex":"Male",
        "age":56.0,
        "age_group":"50.0-58.0 (25%-50%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-D",
        "stage_coding":"AJCC IV C & D",
        "Biopsy_site_tissue":"skin",
        "Progression-free survival event":"N",
        "PFS_days":1583.0,
        "PFS_days_clipped2000":1583.0,
        "Progression-free survival days":"293-1604 days (50%-75%)",
        "response":"R",
        "FFPE Sample Type":"slides",
        "Study_Site":"MIA",
        "ICI_cluster":"ICI-sensitive",
        "TERT":"wildtype",
        "BRAF":"wildtype",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "ARID2":"wildtype"
    },
    "PN03":{
        "cohort":"discovery",
        "sex":"Female",
        "age":46.0,
        "age_group":"<50.0 (25%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-C",
        "stage_coding":"AJCC IV C & D",
        "Biopsy_site_tissue":"skin",
        "Progression-free survival event":"N",
        "PFS_days":2175.0,
        "PFS_days_clipped2000":2001.0,
        "Progression-free survival days":">1604 days (>75%)",
        "response":"R",
        "FFPE Sample Type":"slides",
        "Study_Site":"UPENN",
        "ICI_cluster":"Ribo-high",
        "TERT":"mutant",
        "BRAF":"wildtype",
        "NRAS":"wildtype",
        "NF1":"mutant",
        "ARID2":"wildtype"
    },
    "YU08":{
        "cohort":"discovery",
        "sex":"Male",
        "age":54.0,
        "age_group":"50.0-58.0 (25%-50%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-A",
        "stage_coding":"else",
        "Biopsy_site_tissue":"LN",
        "Progression-free survival event":"Y",
        "PFS_days":198.0,
        "PFS_days_clipped2000":198.0,
        "Progression-free survival days":"102-293 days (25%-50%)",
        "response":"R",
        "FFPE Sample Type":"punch",
        "Study_Site":"YALE",
        "ICI_cluster":"Ribo-high",
        "TERT":null,
        "BRAF":null,
        "NRAS":null,
        "NF1":null,
        "ARID2":null
    },
    "MD05":{
        "cohort":"discovery",
        "sex":"Female",
        "age":47.1704312115,
        "age_group":"<50.0 (25%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-D",
        "stage_coding":"AJCC IV C & D",
        "Biopsy_site_tissue":"skin",
        "Progression-free survival event":"Y",
        "PFS_days":45.0,
        "PFS_days_clipped2000":45.0,
        "Progression-free survival days":"<102 days (25%)",
        "response":"NR",
        "FFPE Sample Type":"slides",
        "Study_Site":"MDACC",
        "ICI_cluster":"Ribo-high",
        "TERT":"mutant",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "ARID2":"wildtype"
    },
    "YU15":{
        "cohort":"discovery",
        "sex":"Male",
        "age":76.0,
        "age_group":">68.0 (>75%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC III (includes B/C/D)",
        "stage_coding":"else",
        "Biopsy_site_tissue":"LN",
        "Progression-free survival event":"Y",
        "PFS_days":148.0,
        "PFS_days_clipped2000":148.0,
        "Progression-free survival days":"102-293 days (25%-50%)",
        "response":"NR",
        "FFPE Sample Type":"slides",
        "Study_Site":"YALE",
        "ICI_cluster":"Ribo-high",
        "TERT":null,
        "BRAF":null,
        "NRAS":null,
        "NF1":null,
        "ARID2":null
    },
    "MD10":{
        "cohort":"discovery",
        "sex":"Male",
        "age":50.1163586585,
        "age_group":"50.0-58.0 (25%-50%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-B",
        "stage_coding":"else",
        "Biopsy_site_tissue":"skin",
        "Progression-free survival event":"N",
        "PFS_days":678.0,
        "PFS_days_clipped2000":678.0,
        "Progression-free survival days":"293-1604 days (50%-75%)",
        "response":"R",
        "FFPE Sample Type":"slides",
        "Study_Site":"MDACC",
        "ICI_cluster":"Ribo-high",
        "TERT":"mutant",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "ARID2":"mutant"
    },
    "MG09":{
        "cohort":"discovery",
        "sex":"Female",
        "age":33.0,
        "age_group":"<50.0 (25%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-A",
        "stage_coding":"else",
        "Biopsy_site_tissue":"LN",
        "Progression-free survival event":"Y",
        "PFS_days":35.0,
        "PFS_days_clipped2000":35.0,
        "Progression-free survival days":"<102 days (25%)",
        "response":"NR",
        "FFPE Sample Type":"punch",
        "Study_Site":"MGH",
        "ICI_cluster":"Ribo-high",
        "TERT":null,
        "BRAF":null,
        "NRAS":null,
        "NF1":null,
        "ARID2":null
    },
    "MD09":{
        "cohort":"discovery",
        "sex":"Male",
        "age":59.794661191,
        "age_group":"58.0-68.0 (50%-75%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC III (includes B/C/D)",
        "stage_coding":"else",
        "Biopsy_site_tissue":"LN",
        "Progression-free survival event":"N",
        "PFS_days":112.0,
        "PFS_days_clipped2000":112.0,
        "Progression-free survival days":"102-293 days (25%-50%)",
        "response":null,
        "FFPE Sample Type":"slides",
        "Study_Site":"MDACC",
        "ICI_cluster":"ICI-sensitive",
        "TERT":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "ARID2":"wildtype"
    },
    "VU10":{
        "cohort":"discovery",
        "sex":"Male",
        "age":62.0,
        "age_group":"58.0-68.0 (50%-75%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-C",
        "stage_coding":"AJCC IV C & D",
        "Biopsy_site_tissue":"skin",
        "Progression-free survival event":"Y",
        "PFS_days":1183.0,
        "PFS_days_clipped2000":1183.0,
        "Progression-free survival days":"293-1604 days (50%-75%)",
        "response":"R",
        "FFPE Sample Type":"gross dissection",
        "Study_Site":"VAND",
        "ICI_cluster":"ICI-sensitive",
        "TERT":null,
        "BRAF":null,
        "NRAS":null,
        "NF1":null,
        "ARID2":null
    },
    "MG08":{
        "cohort":"discovery",
        "sex":"Female",
        "age":38.0,
        "age_group":"<50.0 (25%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-A",
        "stage_coding":"else",
        "Biopsy_site_tissue":"skin",
        "Progression-free survival event":"N",
        "PFS_days":3164.0,
        "PFS_days_clipped2000":2001.0,
        "Progression-free survival days":">1604 days (>75%)",
        "response":"R",
        "FFPE Sample Type":"slides",
        "Study_Site":"MGH",
        "ICI_cluster":"ICI-sensitive",
        "TERT":"mutant",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "ARID2":"wildtype"
    },
    "MD08":{
        "cohort":"discovery",
        "sex":"Male",
        "age":67.3073237509,
        "age_group":"58.0-68.0 (50%-75%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-B",
        "stage_coding":"else",
        "Biopsy_site_tissue":"skin",
        "Progression-free survival event":"Y",
        "PFS_days":104.0,
        "PFS_days_clipped2000":104.0,
        "Progression-free survival days":"102-293 days (25%-50%)",
        "response":"NR",
        "FFPE Sample Type":"slides",
        "Study_Site":"MDACC",
        "ICI_cluster":"Ribo-high",
        "TERT":null,
        "BRAF":null,
        "NRAS":null,
        "NF1":null,
        "ARID2":null
    },
    "YU14":{
        "cohort":"discovery",
        "sex":"Male",
        "age":77.0,
        "age_group":">68.0 (>75%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC III (includes B/C/D)",
        "stage_coding":"else",
        "Biopsy_site_tissue":"LN",
        "Progression-free survival event":"N",
        "PFS_days":2905.0,
        "PFS_days_clipped2000":2001.0,
        "Progression-free survival days":">1604 days (>75%)",
        "response":"R",
        "FFPE Sample Type":"punch",
        "Study_Site":"YALE",
        "ICI_cluster":"Ribo-high",
        "TERT":"mutant",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "ARID2":"mutant"
    },
    "VU12":{
        "cohort":"discovery",
        "sex":"Male",
        "age":61.0,
        "age_group":"58.0-68.0 (50%-75%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-A",
        "stage_coding":"else",
        "Biopsy_site_tissue":"skin",
        "Progression-free survival event":"N",
        "PFS_days":2834.0,
        "PFS_days_clipped2000":2001.0,
        "Progression-free survival days":">1604 days (>75%)",
        "response":"R",
        "FFPE Sample Type":"slides",
        "Study_Site":"VAND",
        "ICI_cluster":"ICI-sensitive",
        "TERT":"mutant",
        "BRAF":"wildtype",
        "NRAS":"mutant",
        "NF1":"wildtype",
        "ARID2":"wildtype"
    },
    "YU10":{
        "cohort":"discovery",
        "sex":"Female",
        "age":64.0,
        "age_group":"58.0-68.0 (50%-75%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC III (includes B/C/D)",
        "stage_coding":"else",
        "Biopsy_site_tissue":"skin",
        "Progression-free survival event":"N",
        "PFS_days":2743.0,
        "PFS_days_clipped2000":2001.0,
        "Progression-free survival days":">1604 days (>75%)",
        "response":"R",
        "FFPE Sample Type":"slides",
        "Study_Site":"YALE",
        "ICI_cluster":"ICI-sensitive",
        "TERT":"mutant",
        "BRAF":"wildtype",
        "NRAS":"mutant",
        "NF1":"mutant",
        "ARID2":"wildtype"
    },
    "MA13":{
        "cohort":"discovery",
        "sex":"Male",
        "age":58.0,
        "age_group":"58.0-68.0 (50%-75%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-D",
        "stage_coding":"AJCC IV C & D",
        "Biopsy_site_tissue":"lung",
        "Progression-free survival event":"Y",
        "PFS_days":81.0,
        "PFS_days_clipped2000":81.0,
        "Progression-free survival days":"<102 days (25%)",
        "response":"NR",
        "FFPE Sample Type":"slides",
        "Study_Site":"MIA",
        "ICI_cluster":"ICI-sensitive",
        "TERT":null,
        "BRAF":null,
        "NRAS":null,
        "NF1":null,
        "ARID2":null
    },
    "VU02":{
        "cohort":"discovery",
        "sex":"Male",
        "age":75.0,
        "age_group":">68.0 (>75%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-B",
        "stage_coding":"else",
        "Biopsy_site_tissue":"skin",
        "Progression-free survival event":"N",
        "PFS_days":2697.0,
        "PFS_days_clipped2000":2001.0,
        "Progression-free survival days":">1604 days (>75%)",
        "response":"R",
        "FFPE Sample Type":"slides",
        "Study_Site":"VAND",
        "ICI_cluster":"ICI-sensitive",
        "TERT":"mutant",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"mutant",
        "ARID2":"wildtype"
    },
    "MA12":{
        "cohort":"discovery",
        "sex":"Male",
        "age":42.0,
        "age_group":"<50.0 (25%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-B",
        "stage_coding":"else",
        "Biopsy_site_tissue":"lung",
        "Progression-free survival event":"N",
        "PFS_days":2471.0,
        "PFS_days_clipped2000":2001.0,
        "Progression-free survival days":">1604 days (>75%)",
        "response":"R",
        "FFPE Sample Type":"slides",
        "Study_Site":"MIA",
        "ICI_cluster":"ICI-sensitive",
        "TERT":"mutant",
        "BRAF":"wildtype",
        "NRAS":"mutant",
        "NF1":"wildtype",
        "ARID2":"wildtype"
    },
    "VU04":{
        "cohort":"discovery",
        "sex":"Male",
        "age":49.0,
        "age_group":"<50.0 (25%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-B",
        "stage_coding":"else",
        "Biopsy_site_tissue":"skin",
        "Progression-free survival event":"N",
        "PFS_days":3020.0,
        "PFS_days_clipped2000":2001.0,
        "Progression-free survival days":">1604 days (>75%)",
        "response":"R",
        "FFPE Sample Type":"gross dissection",
        "Study_Site":"VAND",
        "ICI_cluster":"Ribo-high",
        "TERT":"mutant",
        "BRAF":"wildtype",
        "NRAS":"mutant",
        "NF1":"wildtype",
        "ARID2":"wildtype"
    },
    "MA07":{
        "cohort":"discovery",
        "sex":"Male",
        "age":73.0,
        "age_group":">68.0 (>75%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-C",
        "stage_coding":"AJCC IV C & D",
        "Biopsy_site_tissue":"lung",
        "Progression-free survival event":"N",
        "PFS_days":3039.0,
        "PFS_days_clipped2000":2001.0,
        "Progression-free survival days":">1604 days (>75%)",
        "response":"R",
        "FFPE Sample Type":"slides",
        "Study_Site":"MIA",
        "ICI_cluster":"ICI-sensitive",
        "TERT":null,
        "BRAF":null,
        "NRAS":null,
        "NF1":null,
        "ARID2":null
    },
    "MD04":{
        "cohort":"discovery",
        "sex":"Male",
        "age":54.1163586585,
        "age_group":"50.0-58.0 (25%-50%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-B",
        "stage_coding":"else",
        "Biopsy_site_tissue":"lung",
        "Progression-free survival event":"N",
        "PFS_days":266.0,
        "PFS_days_clipped2000":266.0,
        "Progression-free survival days":"102-293 days (25%-50%)",
        "response":"R",
        "FFPE Sample Type":"gross dissection",
        "Study_Site":"MDACC",
        "ICI_cluster":"ICI-sensitive",
        "TERT":"wildtype",
        "BRAF":"wildtype",
        "NRAS":"mutant",
        "NF1":"wildtype",
        "ARID2":"wildtype"
    },
    "VU03":{
        "cohort":"discovery",
        "sex":"Male",
        "age":77.0,
        "age_group":">68.0 (>75%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-C",
        "stage_coding":"AJCC IV C & D",
        "Biopsy_site_tissue":"LN",
        "Progression-free survival event":"Y",
        "PFS_days":201.0,
        "PFS_days_clipped2000":201.0,
        "Progression-free survival days":"102-293 days (25%-50%)",
        "response":"R",
        "FFPE Sample Type":"slides",
        "Study_Site":"VAND",
        "ICI_cluster":"Ribo-high",
        "TERT":null,
        "BRAF":null,
        "NRAS":null,
        "NF1":null,
        "ARID2":null
    },
    "PT02":{
        "cohort":"discovery",
        "sex":"Male",
        "age":52.0,
        "age_group":"50.0-58.0 (25%-50%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-D",
        "stage_coding":"AJCC IV C & D",
        "Biopsy_site_tissue":"skin",
        "Progression-free survival event":"Y",
        "PFS_days":763.0,
        "PFS_days_clipped2000":763.0,
        "Progression-free survival days":"293-1604 days (50%-75%)",
        "response":"R",
        "FFPE Sample Type":"slides",
        "Study_Site":"UPITT",
        "ICI_cluster":"ICI-sensitive",
        "TERT":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "ARID2":"wildtype"
    },
    "VU08":{
        "cohort":"discovery",
        "sex":"Male",
        "age":60.0,
        "age_group":"58.0-68.0 (50%-75%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-A",
        "stage_coding":"else",
        "Biopsy_site_tissue":"skin",
        "Progression-free survival event":"Y",
        "PFS_days":84.0,
        "PFS_days_clipped2000":84.0,
        "Progression-free survival days":"<102 days (25%)",
        "response":"NR",
        "FFPE Sample Type":"gross dissection",
        "Study_Site":"VAND",
        "ICI_cluster":"Ribo-high",
        "TERT":"mutant",
        "BRAF":"wildtype",
        "NRAS":"mutant",
        "NF1":"wildtype",
        "ARID2":"wildtype"
    },
    "YU23":{
        "cohort":"discovery",
        "sex":"Male",
        "age":75.0,
        "age_group":">68.0 (>75%)",
        "ethnicity":"African-American",
        "AJCC Stage":"AJCC III (includes B/C/D)",
        "stage_coding":"else",
        "Biopsy_site_tissue":"LN",
        "Progression-free survival event":"Y",
        "PFS_days":119.0,
        "PFS_days_clipped2000":119.0,
        "Progression-free survival days":"102-293 days (25%-50%)",
        "response":"NR",
        "FFPE Sample Type":"punch",
        "Study_Site":"YALE",
        "ICI_cluster":"ICI-sensitive",
        "TERT":"wildtype",
        "BRAF":"wildtype",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "ARID2":"wildtype"
    },
    "MG04":{
        "cohort":"discovery",
        "sex":"Male",
        "age":27.0,
        "age_group":"<50.0 (25%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-D",
        "stage_coding":"AJCC IV C & D",
        "Biopsy_site_tissue":"skin",
        "Progression-free survival event":"Y",
        "PFS_days":63.0,
        "PFS_days_clipped2000":63.0,
        "Progression-free survival days":"<102 days (25%)",
        "response":"NR",
        "FFPE Sample Type":"slides",
        "Study_Site":"MGH",
        "ICI_cluster":"EMT-like",
        "TERT":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "ARID2":"wildtype"
    },
    "PN06":{
        "cohort":"discovery",
        "sex":"Female",
        "age":77.0,
        "age_group":">68.0 (>75%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-B",
        "stage_coding":"else",
        "Biopsy_site_tissue":"lung",
        "Progression-free survival event":"Y",
        "PFS_days":133.0,
        "PFS_days_clipped2000":133.0,
        "Progression-free survival days":"102-293 days (25%-50%)",
        "response":"NR",
        "FFPE Sample Type":"slides",
        "Study_Site":"UPENN",
        "ICI_cluster":"EMT-like",
        "TERT":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "ARID2":"wildtype"
    },
    "PT04":{
        "cohort":"discovery",
        "sex":"Male",
        "age":57.0,
        "age_group":"50.0-58.0 (25%-50%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-D",
        "stage_coding":"AJCC IV C & D",
        "Biopsy_site_tissue":"skin",
        "Progression-free survival event":"N",
        "PFS_days":1171.0,
        "PFS_days_clipped2000":1171.0,
        "Progression-free survival days":"293-1604 days (50%-75%)",
        "response":"R",
        "FFPE Sample Type":"slides",
        "Study_Site":"UPITT",
        "ICI_cluster":"ICI-sensitive",
        "TERT":"mutant",
        "BRAF":"wildtype",
        "NRAS":"mutant",
        "NF1":"mutant",
        "ARID2":"wildtype"
    },
    "YU22":{
        "cohort":"discovery",
        "sex":"Male",
        "age":35.0,
        "age_group":"<50.0 (25%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC III (includes B/C/D)",
        "stage_coding":"else",
        "Biopsy_site_tissue":"LN",
        "Progression-free survival event":"Y",
        "PFS_days":103.0,
        "PFS_days_clipped2000":103.0,
        "Progression-free survival days":"102-293 days (25%-50%)",
        "response":"NR",
        "FFPE Sample Type":"gross dissection",
        "Study_Site":"YALE",
        "ICI_cluster":"ICI-sensitive",
        "TERT":"wildtype",
        "BRAF":"wildtype",
        "NRAS":"mutant",
        "NF1":"wildtype",
        "ARID2":"wildtype"
    },
    "YU25":{
        "cohort":"discovery",
        "sex":"Female",
        "age":62.0,
        "age_group":"58.0-68.0 (50%-75%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-A",
        "stage_coding":"else",
        "Biopsy_site_tissue":"LN",
        "Progression-free survival event":"N",
        "PFS_days":2444.0,
        "PFS_days_clipped2000":2001.0,
        "Progression-free survival days":">1604 days (>75%)",
        "response":"R",
        "FFPE Sample Type":"punch",
        "Study_Site":"YALE",
        "ICI_cluster":"Ribo-high",
        "TERT":"mutant",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "ARID2":"mutant"
    },
    "MA11":{
        "cohort":"discovery",
        "sex":"Female",
        "age":52.0,
        "age_group":"50.0-58.0 (25%-50%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-C",
        "stage_coding":"AJCC IV C & D",
        "Biopsy_site_tissue":"lung",
        "Progression-free survival event":"Y",
        "PFS_days":1788.0,
        "PFS_days_clipped2000":1788.0,
        "Progression-free survival days":">1604 days (>75%)",
        "response":"R",
        "FFPE Sample Type":"slides",
        "Study_Site":"MIA",
        "ICI_cluster":"ICI-sensitive",
        "TERT":"wildtype",
        "BRAF":"wildtype",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "ARID2":"wildtype"
    },
    "MG11":{
        "cohort":"discovery",
        "sex":"Male",
        "age":59.0,
        "age_group":"58.0-68.0 (50%-75%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-B",
        "stage_coding":"else",
        "Biopsy_site_tissue":"skin",
        "Progression-free survival event":"N",
        "PFS_days":2260.0,
        "PFS_days_clipped2000":2001.0,
        "Progression-free survival days":">1604 days (>75%)",
        "response":"R",
        "FFPE Sample Type":"slides",
        "Study_Site":"MGH",
        "ICI_cluster":"Ribo-high",
        "TERT":"wildtype",
        "BRAF":"wildtype",
        "NRAS":"wildtype",
        "NF1":"mutant",
        "ARID2":"wildtype"
    },
    "MD06":{
        "cohort":"discovery",
        "sex":"Male",
        "age":55.2224503765,
        "age_group":"50.0-58.0 (25%-50%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-C",
        "stage_coding":"AJCC IV C & D",
        "Biopsy_site_tissue":"skin",
        "Progression-free survival event":"Y",
        "PFS_days":136.0,
        "PFS_days_clipped2000":136.0,
        "Progression-free survival days":"102-293 days (25%-50%)",
        "response":"NR",
        "FFPE Sample Type":"gross dissection",
        "Study_Site":"MDACC",
        "ICI_cluster":"Ribo-high",
        "TERT":"mutant",
        "BRAF":"wildtype",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "ARID2":"wildtype"
    },
    "MA06":{
        "cohort":"discovery",
        "sex":"Male",
        "age":41.0,
        "age_group":"<50.0 (25%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-D",
        "stage_coding":"AJCC IV C & D",
        "Biopsy_site_tissue":"skin",
        "Progression-free survival event":"Y",
        "PFS_days":62.0,
        "PFS_days_clipped2000":62.0,
        "Progression-free survival days":"<102 days (25%)",
        "response":"NR",
        "FFPE Sample Type":"slides",
        "Study_Site":"MIA",
        "ICI_cluster":"EMT-like",
        "TERT":"wildtype",
        "BRAF":"wildtype",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "ARID2":"wildtype"
    },
    "MG05":{
        "cohort":"discovery",
        "sex":"Male",
        "age":61.0,
        "age_group":"58.0-68.0 (50%-75%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-C",
        "stage_coding":"AJCC IV C & D",
        "Biopsy_site_tissue":"LN",
        "Progression-free survival event":"Y",
        "PFS_days":284.0,
        "PFS_days_clipped2000":284.0,
        "Progression-free survival days":"102-293 days (25%-50%)",
        "response":"R",
        "FFPE Sample Type":"slides",
        "Study_Site":"MGH",
        "ICI_cluster":"Ribo-high",
        "TERT":null,
        "BRAF":null,
        "NRAS":null,
        "NF1":null,
        "ARID2":null
    },
    "MG01":{
        "cohort":"discovery",
        "sex":"Male",
        "age":83.0,
        "age_group":">68.0 (>75%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-A",
        "stage_coding":"else",
        "Biopsy_site_tissue":"LN",
        "Progression-free survival event":"Y",
        "PFS_days":39.0,
        "PFS_days_clipped2000":39.0,
        "Progression-free survival days":"<102 days (25%)",
        "response":"NR",
        "FFPE Sample Type":"gross dissection",
        "Study_Site":"MGH",
        "ICI_cluster":"EMT-like",
        "TERT":"mutant",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "ARID2":"wildtype"
    },
    "MA10":{
        "cohort":"discovery",
        "sex":"Female",
        "age":22.0,
        "age_group":"<50.0 (25%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-A",
        "stage_coding":"else",
        "Biopsy_site_tissue":"skin",
        "Progression-free survival event":"N",
        "PFS_days":3329.0,
        "PFS_days_clipped2000":2001.0,
        "Progression-free survival days":">1604 days (>75%)",
        "response":"R",
        "FFPE Sample Type":"slides",
        "Study_Site":"MIA",
        "ICI_cluster":"ICI-sensitive",
        "TERT":"mutant",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"mutant",
        "ARID2":"wildtype"
    },
    "MA19":{
        "cohort":"discovery",
        "sex":"Male",
        "age":55.0,
        "age_group":"50.0-58.0 (25%-50%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-D",
        "stage_coding":"AJCC IV C & D",
        "Biopsy_site_tissue":"skin",
        "Progression-free survival event":"N",
        "PFS_days":868.0,
        "PFS_days_clipped2000":868.0,
        "Progression-free survival days":"293-1604 days (50%-75%)",
        "response":"R",
        "FFPE Sample Type":"slides",
        "Study_Site":"MIA",
        "ICI_cluster":"ICI-sensitive",
        "TERT":null,
        "BRAF":null,
        "NRAS":null,
        "NF1":null,
        "ARID2":null
    },
    "YU05":{
        "cohort":"discovery",
        "sex":"Male",
        "age":72.0,
        "age_group":">68.0 (>75%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC III (includes B/C/D)",
        "stage_coding":"else",
        "Biopsy_site_tissue":"LN",
        "Progression-free survival event":"Y",
        "PFS_days":44.0,
        "PFS_days_clipped2000":44.0,
        "Progression-free survival days":"<102 days (25%)",
        "response":"NR",
        "FFPE Sample Type":"punch",
        "Study_Site":"YALE",
        "ICI_cluster":"EMT-like",
        "TERT":null,
        "BRAF":null,
        "NRAS":null,
        "NF1":null,
        "ARID2":null
    },
    "VU13":{
        "cohort":"discovery",
        "sex":"Male",
        "age":57.0,
        "age_group":"50.0-58.0 (25%-50%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-D",
        "stage_coding":"AJCC IV C & D",
        "Biopsy_site_tissue":"LN",
        "Progression-free survival event":"Y",
        "PFS_days":302.0,
        "PFS_days_clipped2000":302.0,
        "Progression-free survival days":"293-1604 days (50%-75%)",
        "response":"R",
        "FFPE Sample Type":"gross dissection",
        "Study_Site":"VAND",
        "ICI_cluster":"ICI-sensitive",
        "TERT":"wildtype",
        "BRAF":"wildtype",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "ARID2":"wildtype"
    },
    "MG06":{
        "cohort":"discovery",
        "sex":"Male",
        "age":68.0,
        "age_group":">68.0 (>75%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-C",
        "stage_coding":"AJCC IV C & D",
        "Biopsy_site_tissue":"LN",
        "Progression-free survival event":"Y",
        "PFS_days":154.0,
        "PFS_days_clipped2000":154.0,
        "Progression-free survival days":"102-293 days (25%-50%)",
        "response":"NR",
        "FFPE Sample Type":"slides",
        "Study_Site":"MGH",
        "ICI_cluster":"Ribo-high",
        "TERT":"wildtype",
        "BRAF":"wildtype",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "ARID2":"wildtype"
    },
    "MA05":{
        "cohort":"discovery",
        "sex":"Female",
        "age":57.0,
        "age_group":"50.0-58.0 (25%-50%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-B",
        "stage_coding":"else",
        "Biopsy_site_tissue":"lung",
        "Progression-free survival event":"N",
        "PFS_days":3185.0,
        "PFS_days_clipped2000":2001.0,
        "Progression-free survival days":">1604 days (>75%)",
        "response":"R",
        "FFPE Sample Type":"slides",
        "Study_Site":"MIA",
        "ICI_cluster":"ICI-sensitive",
        "TERT":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "ARID2":"wildtype"
    },
    "MA08":{
        "cohort":"discovery",
        "sex":"Male",
        "age":42.0,
        "age_group":"<50.0 (25%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-B",
        "stage_coding":"else",
        "Biopsy_site_tissue":"skin",
        "Progression-free survival event":"Y",
        "PFS_days":89.0,
        "PFS_days_clipped2000":89.0,
        "Progression-free survival days":"<102 days (25%)",
        "response":"NR",
        "FFPE Sample Type":"gross dissection",
        "Study_Site":"MIA",
        "ICI_cluster":"EMT-like",
        "TERT":"mutant",
        "BRAF":"wildtype",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "ARID2":"mutant"
    },
    "CR15":{
        "cohort":"validation",
        "sex":"Male",
        "age":54.0,
        "age_group":"50.0-58.0 (25%-50%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-C",
        "stage_coding":"AJCC IV C & D",
        "Biopsy_site_tissue":"LN",
        "Progression-free survival event":"N",
        "PFS_days":284.0,
        "PFS_days_clipped2000":284.0,
        "Progression-free survival days":"102-293 days (25%-50%)",
        "response":"R",
        "FFPE Sample Type":null,
        "Study_Site":"POL",
        "ICI_cluster":"ICI-sensitive",
        "TERT":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "ARID2":"wildtype"
    },
    "SK04":{
        "cohort":"validation",
        "sex":"Male",
        "age":74.0,
        "age_group":">68.0 (>75%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-D",
        "stage_coding":"AJCC IV C & D",
        "Biopsy_site_tissue":"LN",
        "Progression-free survival event":"Y",
        "PFS_days":88.0,
        "PFS_days_clipped2000":88.0,
        "Progression-free survival days":"<102 days (25%)",
        "response":"NR",
        "FFPE Sample Type":null,
        "Study_Site":"MSK",
        "ICI_cluster":"ICI-sensitive",
        "TERT":"mutant",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "ARID2":"wildtype"
    },
    "CR16":{
        "cohort":"validation",
        "sex":"Female",
        "age":36.0,
        "age_group":"<50.0 (25%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-C",
        "stage_coding":"AJCC IV C & D",
        "Biopsy_site_tissue":"LN",
        "Progression-free survival event":"N",
        "PFS_days":362.0,
        "PFS_days_clipped2000":362.0,
        "Progression-free survival days":"293-1604 days (50%-75%)",
        "response":"R",
        "FFPE Sample Type":null,
        "Study_Site":"POL",
        "ICI_cluster":"Ribo-high",
        "TERT":"mutant",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "ARID2":"wildtype"
    },
    "GR18":{
        "cohort":"validation",
        "sex":"Male",
        "age":34.0,
        "age_group":"<50.0 (25%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-C",
        "stage_coding":"AJCC IV C & D",
        "Biopsy_site_tissue":"skin",
        "Progression-free survival event":"Y",
        "PFS_days":182.0,
        "PFS_days_clipped2000":182.0,
        "Progression-free survival days":"102-293 days (25%-50%)",
        "response":"R",
        "FFPE Sample Type":null,
        "Study_Site":"GE",
        "ICI_cluster":"Ribo-high",
        "TERT":"mutant",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "ARID2":"wildtype"
    },
    "GR06":{
        "cohort":"validation",
        "sex":"Female",
        "age":50.0,
        "age_group":"50.0-58.0 (25%-50%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-C",
        "stage_coding":"AJCC IV C & D",
        "Biopsy_site_tissue":"skin",
        "Progression-free survival event":"Y",
        "PFS_days":22.0,
        "PFS_days_clipped2000":22.0,
        "Progression-free survival days":"<102 days (25%)",
        "response":"NR",
        "FFPE Sample Type":null,
        "Study_Site":"GE",
        "ICI_cluster":"Ribo-high",
        "TERT":"mutant",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"mutant",
        "ARID2":"wildtype"
    },
    "SK01":{
        "cohort":"validation",
        "sex":"Female",
        "age":64.0,
        "age_group":"58.0-68.0 (50%-75%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-C",
        "stage_coding":"AJCC IV C & D",
        "Biopsy_site_tissue":"LN",
        "Progression-free survival event":"Y",
        "PFS_days":252.0,
        "PFS_days_clipped2000":252.0,
        "Progression-free survival days":"102-293 days (25%-50%)",
        "response":"R",
        "FFPE Sample Type":null,
        "Study_Site":"MSK",
        "ICI_cluster":"ICI-sensitive",
        "TERT":"mutant",
        "BRAF":"wildtype",
        "NRAS":"wildtype",
        "NF1":"mutant",
        "ARID2":"wildtype"
    },
    "SK08":{
        "cohort":"validation",
        "sex":"Male",
        "age":52.0,
        "age_group":"50.0-58.0 (25%-50%)",
        "ethnicity":"non-Caucasian",
        "AJCC Stage":"AJCC IV-A",
        "stage_coding":"else",
        "Biopsy_site_tissue":"skin",
        "Progression-free survival event":"Y",
        "PFS_days":83.0,
        "PFS_days_clipped2000":83.0,
        "Progression-free survival days":"<102 days (25%)",
        "response":"NR",
        "FFPE Sample Type":null,
        "Study_Site":"MSK",
        "ICI_cluster":"ICI-sensitive",
        "TERT":"wildtype",
        "BRAF":"wildtype",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "ARID2":"wildtype"
    },
    "CR08":{
        "cohort":"validation",
        "sex":"Female",
        "age":59.0,
        "age_group":"58.0-68.0 (50%-75%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC III (includes B/C/D)",
        "stage_coding":"else",
        "Biopsy_site_tissue":"skin",
        "Progression-free survival event":"N",
        "PFS_days":156.0,
        "PFS_days_clipped2000":156.0,
        "Progression-free survival days":"102-293 days (25%-50%)",
        "response":null,
        "FFPE Sample Type":null,
        "Study_Site":"POL",
        "ICI_cluster":"ICI-sensitive",
        "TERT":null,
        "BRAF":null,
        "NRAS":null,
        "NF1":null,
        "ARID2":null
    },
    "NY09":{
        "cohort":"validation",
        "sex":"Female",
        "age":23.0082191781,
        "age_group":"<50.0 (25%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-C",
        "stage_coding":"AJCC IV C & D",
        "Biopsy_site_tissue":"skin",
        "Progression-free survival event":"N",
        "PFS_days":3243.0,
        "PFS_days_clipped2000":2001.0,
        "Progression-free survival days":">1604 days (>75%)",
        "response":"R",
        "FFPE Sample Type":null,
        "Study_Site":"NY",
        "ICI_cluster":"ICI-sensitive",
        "TERT":"wildtype",
        "BRAF":"wildtype",
        "NRAS":"mutant",
        "NF1":"wildtype",
        "ARID2":"wildtype"
    },
    "GR14":{
        "cohort":"validation",
        "sex":"Male",
        "age":61.0,
        "age_group":"58.0-68.0 (50%-75%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-D",
        "stage_coding":"AJCC IV C & D",
        "Biopsy_site_tissue":"skin",
        "Progression-free survival event":"N",
        "PFS_days":1007.0,
        "PFS_days_clipped2000":1007.0,
        "Progression-free survival days":"293-1604 days (50%-75%)",
        "response":"R",
        "FFPE Sample Type":null,
        "Study_Site":"GE",
        "ICI_cluster":"Ribo-high",
        "TERT":"mutant",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "ARID2":"wildtype"
    },
    "CR06":{
        "cohort":"validation",
        "sex":"Female",
        "age":52.0,
        "age_group":"50.0-58.0 (25%-50%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-C",
        "stage_coding":"AJCC IV C & D",
        "Biopsy_site_tissue":"LN",
        "Progression-free survival event":"N",
        "PFS_days":280.0,
        "PFS_days_clipped2000":280.0,
        "Progression-free survival days":"102-293 days (25%-50%)",
        "response":"R",
        "FFPE Sample Type":null,
        "Study_Site":"POL",
        "ICI_cluster":"Ribo-high",
        "TERT":"mutant",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "ARID2":"wildtype"
    },
    "MD13":{
        "cohort":"validation",
        "sex":"Male",
        "age":23.0308008214,
        "age_group":"<50.0 (25%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-D",
        "stage_coding":"AJCC IV C & D",
        "Biopsy_site_tissue":"skin",
        "Progression-free survival event":"N",
        "PFS_days":2625.0,
        "PFS_days_clipped2000":2001.0,
        "Progression-free survival days":">1604 days (>75%)",
        "response":"R",
        "FFPE Sample Type":null,
        "Study_Site":"MDACC",
        "ICI_cluster":"ICI-sensitive",
        "TERT":"mutant",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "ARID2":"wildtype"
    },
    "CR12":{
        "cohort":"validation",
        "sex":"Male",
        "age":40.0,
        "age_group":"<50.0 (25%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-C",
        "stage_coding":"AJCC IV C & D",
        "Biopsy_site_tissue":"LN",
        "Progression-free survival event":"Y",
        "PFS_days":252.0,
        "PFS_days_clipped2000":252.0,
        "Progression-free survival days":"102-293 days (25%-50%)",
        "response":"R",
        "FFPE Sample Type":null,
        "Study_Site":"POL",
        "ICI_cluster":"ICI-sensitive",
        "TERT":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "ARID2":"wildtype"
    },
    "NY05":{
        "cohort":"validation",
        "sex":"Female",
        "age":62.3,
        "age_group":"58.0-68.0 (50%-75%)",
        "ethnicity":"non-Caucasian",
        "AJCC Stage":"AJCC IV-B",
        "stage_coding":"else",
        "Biopsy_site_tissue":"lung",
        "Progression-free survival event":"Y",
        "PFS_days":79.0,
        "PFS_days_clipped2000":79.0,
        "Progression-free survival days":"<102 days (25%)",
        "response":"NR",
        "FFPE Sample Type":null,
        "Study_Site":"NY",
        "ICI_cluster":"EMT-like",
        "TERT":"mutant",
        "BRAF":"wildtype",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "ARID2":"mutant"
    },
    "GR13":{
        "cohort":"validation",
        "sex":"Female",
        "age":80.0,
        "age_group":">68.0 (>75%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-D",
        "stage_coding":"AJCC IV C & D",
        "Biopsy_site_tissue":"LN",
        "Progression-free survival event":"N",
        "PFS_days":1172.0,
        "PFS_days_clipped2000":1172.0,
        "Progression-free survival days":"293-1604 days (50%-75%)",
        "response":"R",
        "FFPE Sample Type":null,
        "Study_Site":"GE",
        "ICI_cluster":"Ribo-high",
        "TERT":"mutant",
        "BRAF":"wildtype",
        "NRAS":"mutant",
        "NF1":"wildtype",
        "ARID2":"wildtype"
    },
    "MA25":{
        "cohort":"validation",
        "sex":"Male",
        "age":68.0,
        "age_group":">68.0 (>75%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-A",
        "stage_coding":"else",
        "Biopsy_site_tissue":"skin",
        "Progression-free survival event":"Y",
        "PFS_days":1955.0,
        "PFS_days_clipped2000":1955.0,
        "Progression-free survival days":">1604 days (>75%)",
        "response":"R",
        "FFPE Sample Type":null,
        "Study_Site":"MIA",
        "ICI_cluster":"EMT-like",
        "TERT":"mutant",
        "BRAF":"wildtype",
        "NRAS":"wildtype",
        "NF1":"mutant",
        "ARID2":"mutant"
    },
    "MA26":{
        "cohort":"validation",
        "sex":"Male",
        "age":54.0,
        "age_group":"50.0-58.0 (25%-50%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-D",
        "stage_coding":"AJCC IV C & D",
        "Biopsy_site_tissue":"skin",
        "Progression-free survival event":"Y",
        "PFS_days":70.0,
        "PFS_days_clipped2000":70.0,
        "Progression-free survival days":"<102 days (25%)",
        "response":"NR",
        "FFPE Sample Type":null,
        "Study_Site":"MIA",
        "ICI_cluster":"Ribo-high",
        "TERT":null,
        "BRAF":null,
        "NRAS":null,
        "NF1":null,
        "ARID2":null
    },
    "GR16":{
        "cohort":"validation",
        "sex":"Female",
        "age":70.0,
        "age_group":">68.0 (>75%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-D",
        "stage_coding":"AJCC IV C & D",
        "Biopsy_site_tissue":"skin",
        "Progression-free survival event":"Y",
        "PFS_days":40.0,
        "PFS_days_clipped2000":40.0,
        "Progression-free survival days":"<102 days (25%)",
        "response":"NR",
        "FFPE Sample Type":null,
        "Study_Site":"GE",
        "ICI_cluster":"Ribo-high",
        "TERT":"mutant",
        "BRAF":"wildtype",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "ARID2":"wildtype"
    },
    "CR13":{
        "cohort":"validation",
        "sex":"Male",
        "age":60.0,
        "age_group":"58.0-68.0 (50%-75%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-A",
        "stage_coding":"else",
        "Biopsy_site_tissue":"LN",
        "Progression-free survival event":"Y",
        "PFS_days":995.0,
        "PFS_days_clipped2000":995.0,
        "Progression-free survival days":"293-1604 days (50%-75%)",
        "response":"R",
        "FFPE Sample Type":null,
        "Study_Site":"POL",
        "ICI_cluster":"Ribo-high",
        "TERT":"mutant",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "ARID2":"wildtype"
    },
    "CR10":{
        "cohort":"validation",
        "sex":"Female",
        "age":50.0,
        "age_group":"50.0-58.0 (25%-50%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-A",
        "stage_coding":"else",
        "Biopsy_site_tissue":"LN",
        "Progression-free survival event":"N",
        "PFS_days":197.0,
        "PFS_days_clipped2000":197.0,
        "Progression-free survival days":"102-293 days (25%-50%)",
        "response":"R",
        "FFPE Sample Type":null,
        "Study_Site":"POL",
        "ICI_cluster":"ICI-sensitive",
        "TERT":"mutant",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "ARID2":"wildtype"
    },
    "GR11":{
        "cohort":"validation",
        "sex":"Male",
        "age":63.0,
        "age_group":"58.0-68.0 (50%-75%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-D",
        "stage_coding":"AJCC IV C & D",
        "Biopsy_site_tissue":"skin",
        "Progression-free survival event":"N",
        "PFS_days":436.0,
        "PFS_days_clipped2000":436.0,
        "Progression-free survival days":"293-1604 days (50%-75%)",
        "response":"R",
        "FFPE Sample Type":null,
        "Study_Site":"GE",
        "ICI_cluster":"Ribo-high",
        "TERT":"mutant",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "ARID2":"wildtype"
    },
    "GR10":{
        "cohort":"validation",
        "sex":"Male",
        "age":69.0,
        "age_group":">68.0 (>75%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-D",
        "stage_coding":"AJCC IV C & D",
        "Biopsy_site_tissue":"skin",
        "Progression-free survival event":"Y",
        "PFS_days":89.0,
        "PFS_days_clipped2000":89.0,
        "Progression-free survival days":"<102 days (25%)",
        "response":"NR",
        "FFPE Sample Type":null,
        "Study_Site":"GE",
        "ICI_cluster":"Ribo-high",
        "TERT":"mutant",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "ARID2":"wildtype"
    },
    "MI06":{
        "cohort":"validation",
        "sex":"Female",
        "age":69.0,
        "age_group":">68.0 (>75%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-B",
        "stage_coding":"else",
        "Biopsy_site_tissue":"LN",
        "Progression-free survival event":"N",
        "PFS_days":1467.0,
        "PFS_days_clipped2000":1467.0,
        "Progression-free survival days":"293-1604 days (50%-75%)",
        "response":"R",
        "FFPE Sample Type":null,
        "Study_Site":"UM",
        "ICI_cluster":"ICI-sensitive",
        "TERT":"mutant",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"mutant",
        "ARID2":"wildtype"
    },
    "GR26":{
        "cohort":"validation",
        "sex":"Female",
        "age":75.0,
        "age_group":">68.0 (>75%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-B",
        "stage_coding":"else",
        "Biopsy_site_tissue":"skin",
        "Progression-free survival event":"Y",
        "PFS_days":72.0,
        "PFS_days_clipped2000":72.0,
        "Progression-free survival days":"<102 days (25%)",
        "response":"NR",
        "FFPE Sample Type":null,
        "Study_Site":"GE",
        "ICI_cluster":"EMT-like",
        "TERT":"mutant",
        "BRAF":"mutant",
        "NRAS":"mutant",
        "NF1":"wildtype",
        "ARID2":"wildtype"
    },
    "CR02":{
        "cohort":"validation",
        "sex":"Male",
        "age":57.0,
        "age_group":"50.0-58.0 (25%-50%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-C",
        "stage_coding":"AJCC IV C & D",
        "Biopsy_site_tissue":"skin",
        "Progression-free survival event":"Y",
        "PFS_days":76.0,
        "PFS_days_clipped2000":76.0,
        "Progression-free survival days":"<102 days (25%)",
        "response":"NR",
        "FFPE Sample Type":null,
        "Study_Site":"POL",
        "ICI_cluster":"Ribo-high",
        "TERT":"wildtype",
        "BRAF":"wildtype",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "ARID2":"wildtype"
    },
    "GR08":{
        "cohort":"validation",
        "sex":"Female",
        "age":39.0,
        "age_group":"<50.0 (25%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-A",
        "stage_coding":"else",
        "Biopsy_site_tissue":"skin",
        "Progression-free survival event":"Y",
        "PFS_days":27.0,
        "PFS_days_clipped2000":27.0,
        "Progression-free survival days":"<102 days (25%)",
        "response":"NR",
        "FFPE Sample Type":null,
        "Study_Site":"GE",
        "ICI_cluster":"Ribo-high",
        "TERT":"wildtype",
        "BRAF":"wildtype",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "ARID2":"wildtype"
    },
    "NY01":{
        "cohort":"validation",
        "sex":"Male",
        "age":69.0,
        "age_group":">68.0 (>75%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-D",
        "stage_coding":"AJCC IV C & D",
        "Biopsy_site_tissue":"LN",
        "Progression-free survival event":"Y",
        "PFS_days":189.0,
        "PFS_days_clipped2000":189.0,
        "Progression-free survival days":"102-293 days (25%-50%)",
        "response":"R",
        "FFPE Sample Type":null,
        "Study_Site":"NY",
        "ICI_cluster":"Ribo-high",
        "TERT":"wildtype",
        "BRAF":"wildtype",
        "NRAS":"mutant",
        "NF1":"wildtype",
        "ARID2":"mutant"
    },
    "CR04":{
        "cohort":"validation",
        "sex":"Male",
        "age":62.0,
        "age_group":"58.0-68.0 (50%-75%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-C",
        "stage_coding":"AJCC IV C & D",
        "Biopsy_site_tissue":"skin",
        "Progression-free survival event":"Y",
        "PFS_days":79.0,
        "PFS_days_clipped2000":79.0,
        "Progression-free survival days":"<102 days (25%)",
        "response":"NR",
        "FFPE Sample Type":null,
        "Study_Site":"POL",
        "ICI_cluster":"Ribo-high",
        "TERT":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "ARID2":"wildtype"
    },
    "GR02":{
        "cohort":"validation",
        "sex":"Female",
        "age":51.0,
        "age_group":"50.0-58.0 (25%-50%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-B",
        "stage_coding":"else",
        "Biopsy_site_tissue":"LN",
        "Progression-free survival event":"N",
        "PFS_days":2037.0,
        "PFS_days_clipped2000":2001.0,
        "Progression-free survival days":">1604 days (>75%)",
        "response":"R",
        "FFPE Sample Type":null,
        "Study_Site":"GE",
        "ICI_cluster":"Ribo-high",
        "TERT":"mutant",
        "BRAF":"wildtype",
        "NRAS":"mutant",
        "NF1":"wildtype",
        "ARID2":"wildtype"
    },
    "CR22":{
        "cohort":"validation",
        "sex":"Male",
        "age":70.0,
        "age_group":">68.0 (>75%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-A",
        "stage_coding":"else",
        "Biopsy_site_tissue":"skin",
        "Progression-free survival event":"N",
        "PFS_days":258.0,
        "PFS_days_clipped2000":258.0,
        "Progression-free survival days":"102-293 days (25%-50%)",
        "response":"R",
        "FFPE Sample Type":null,
        "Study_Site":"POL",
        "ICI_cluster":"ICI-sensitive",
        "TERT":null,
        "BRAF":null,
        "NRAS":null,
        "NF1":null,
        "ARID2":null
    },
    "MI01":{
        "cohort":"validation",
        "sex":"Male",
        "age":76.0,
        "age_group":">68.0 (>75%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-B",
        "stage_coding":"else",
        "Biopsy_site_tissue":"lung",
        "Progression-free survival event":"N",
        "PFS_days":1735.0,
        "PFS_days_clipped2000":1735.0,
        "Progression-free survival days":">1604 days (>75%)",
        "response":"R",
        "FFPE Sample Type":null,
        "Study_Site":"UM",
        "ICI_cluster":"EMT-like",
        "TERT":"mutant",
        "BRAF":"wildtype",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "ARID2":"mutant"
    },
    "NY04":{
        "cohort":"validation",
        "sex":"Female",
        "age":39.0,
        "age_group":"<50.0 (25%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-A",
        "stage_coding":"else",
        "Biopsy_site_tissue":"LN",
        "Progression-free survival event":"Y",
        "PFS_days":114.0,
        "PFS_days_clipped2000":114.0,
        "Progression-free survival days":"102-293 days (25%-50%)",
        "response":"NR",
        "FFPE Sample Type":null,
        "Study_Site":"NY",
        "ICI_cluster":"Ribo-high",
        "TERT":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "ARID2":"wildtype"
    },
    "GR12":{
        "cohort":"validation",
        "sex":"Male",
        "age":50.0,
        "age_group":"50.0-58.0 (25%-50%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-D",
        "stage_coding":"AJCC IV C & D",
        "Biopsy_site_tissue":"skin",
        "Progression-free survival event":"N",
        "PFS_days":1752.0,
        "PFS_days_clipped2000":1752.0,
        "Progression-free survival days":">1604 days (>75%)",
        "response":"R",
        "FFPE Sample Type":null,
        "Study_Site":"GE",
        "ICI_cluster":"ICI-sensitive",
        "TERT":"mutant",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "ARID2":"wildtype"
    },
    "SK03":{
        "cohort":"validation",
        "sex":"Male",
        "age":61.0,
        "age_group":"58.0-68.0 (50%-75%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-A",
        "stage_coding":"else",
        "Biopsy_site_tissue":"skin",
        "Progression-free survival event":"Y",
        "PFS_days":35.0,
        "PFS_days_clipped2000":35.0,
        "Progression-free survival days":"<102 days (25%)",
        "response":"NR",
        "FFPE Sample Type":null,
        "Study_Site":"MSK",
        "ICI_cluster":"Ribo-high",
        "TERT":"mutant",
        "BRAF":"wildtype",
        "NRAS":"mutant",
        "NF1":"wildtype",
        "ARID2":"mutant"
    },
    "GR19":{
        "cohort":"validation",
        "sex":"Male",
        "age":75.0,
        "age_group":">68.0 (>75%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-C",
        "stage_coding":"AJCC IV C & D",
        "Biopsy_site_tissue":"skin",
        "Progression-free survival event":"Y",
        "PFS_days":27.0,
        "PFS_days_clipped2000":27.0,
        "Progression-free survival days":"<102 days (25%)",
        "response":"NR",
        "FFPE Sample Type":null,
        "Study_Site":"GE",
        "ICI_cluster":"EMT-like",
        "TERT":"mutant",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "ARID2":"wildtype"
    },
    "MI05":{
        "cohort":"validation",
        "sex":"Male",
        "age":77.0,
        "age_group":">68.0 (>75%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-C",
        "stage_coding":"AJCC IV C & D",
        "Biopsy_site_tissue":"skin",
        "Progression-free survival event":"N",
        "PFS_days":1393.0,
        "PFS_days_clipped2000":1393.0,
        "Progression-free survival days":"293-1604 days (50%-75%)",
        "response":"R",
        "FFPE Sample Type":null,
        "Study_Site":"UM",
        "ICI_cluster":"ICI-sensitive",
        "TERT":"mutant",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"mutant",
        "ARID2":"wildtype"
    },
    "MD12":{
        "cohort":"validation",
        "sex":"Male",
        "age":47.6796714579,
        "age_group":"<50.0 (25%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-B",
        "stage_coding":"else",
        "Biopsy_site_tissue":"skin",
        "Progression-free survival event":"N",
        "PFS_days":1675.0,
        "PFS_days_clipped2000":1675.0,
        "Progression-free survival days":">1604 days (>75%)",
        "response":"R",
        "FFPE Sample Type":null,
        "Study_Site":"MDACC",
        "ICI_cluster":"Ribo-high",
        "TERT":"mutant",
        "BRAF":"wildtype",
        "NRAS":"wildtype",
        "NF1":"mutant",
        "ARID2":"wildtype"
    },
    "MA24":{
        "cohort":"validation",
        "sex":"Female",
        "age":67.0,
        "age_group":"58.0-68.0 (50%-75%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-D",
        "stage_coding":"AJCC IV C & D",
        "Biopsy_site_tissue":"skin",
        "Progression-free survival event":"Y",
        "PFS_days":108.0,
        "PFS_days_clipped2000":108.0,
        "Progression-free survival days":"102-293 days (25%-50%)",
        "response":"NR",
        "FFPE Sample Type":null,
        "Study_Site":"MIA",
        "ICI_cluster":"ICI-sensitive",
        "TERT":"wildtype",
        "BRAF":"wildtype",
        "NRAS":"mutant",
        "NF1":"wildtype",
        "ARID2":"wildtype"
    },
    "CR05":{
        "cohort":"validation",
        "sex":"Female",
        "age":63.0,
        "age_group":"58.0-68.0 (50%-75%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-B",
        "stage_coding":"else",
        "Biopsy_site_tissue":"skin",
        "Progression-free survival event":"N",
        "PFS_days":1021.0,
        "PFS_days_clipped2000":1021.0,
        "Progression-free survival days":"293-1604 days (50%-75%)",
        "response":"R",
        "FFPE Sample Type":null,
        "Study_Site":"POL",
        "ICI_cluster":"Ribo-high",
        "TERT":"mutant",
        "BRAF":"wildtype",
        "NRAS":"mutant",
        "NF1":"wildtype",
        "ARID2":"wildtype"
    },
    "MI03":{
        "cohort":"validation",
        "sex":"Male",
        "age":72.0,
        "age_group":">68.0 (>75%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-C",
        "stage_coding":"AJCC IV C & D",
        "Biopsy_site_tissue":"skin",
        "Progression-free survival event":"Y",
        "PFS_days":95.0,
        "PFS_days_clipped2000":95.0,
        "Progression-free survival days":"<102 days (25%)",
        "response":"NR",
        "FFPE Sample Type":null,
        "Study_Site":"UM",
        "ICI_cluster":"Ribo-high",
        "TERT":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "ARID2":"mutant"
    },
    "GR17":{
        "cohort":"validation",
        "sex":"Male",
        "age":35.0,
        "age_group":"<50.0 (25%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC III (includes B/C/D)",
        "stage_coding":"else",
        "Biopsy_site_tissue":"LN",
        "Progression-free survival event":"N",
        "PFS_days":934.0,
        "PFS_days_clipped2000":934.0,
        "Progression-free survival days":"293-1604 days (50%-75%)",
        "response":"R",
        "FFPE Sample Type":null,
        "Study_Site":"GE",
        "ICI_cluster":"ICI-sensitive",
        "TERT":"mutant",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "ARID2":"wildtype"
    },
    "GR03":{
        "cohort":"validation",
        "sex":"Female",
        "age":46.0,
        "age_group":"<50.0 (25%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-C",
        "stage_coding":"AJCC IV C & D",
        "Biopsy_site_tissue":"LN",
        "Progression-free survival event":"N",
        "PFS_days":2070.0,
        "PFS_days_clipped2000":2001.0,
        "Progression-free survival days":">1604 days (>75%)",
        "response":"R",
        "FFPE Sample Type":null,
        "Study_Site":"GE",
        "ICI_cluster":"ICI-sensitive",
        "TERT":"mutant",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "ARID2":"wildtype"
    },
    "MD11":{
        "cohort":"validation",
        "sex":"Male",
        "age":62.3819301848,
        "age_group":"58.0-68.0 (50%-75%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-C",
        "stage_coding":"AJCC IV C & D",
        "Biopsy_site_tissue":"skin",
        "Progression-free survival event":"Y",
        "PFS_days":109.0,
        "PFS_days_clipped2000":109.0,
        "Progression-free survival days":"102-293 days (25%-50%)",
        "response":"NR",
        "FFPE Sample Type":null,
        "Study_Site":"MDACC",
        "ICI_cluster":"ICI-sensitive",
        "TERT":"mutant",
        "BRAF":"wildtype",
        "NRAS":"wildtype",
        "NF1":"mutant",
        "ARID2":"wildtype"
    },
    "CR21":{
        "cohort":"validation",
        "sex":"Female",
        "age":64.0,
        "age_group":"58.0-68.0 (50%-75%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-C",
        "stage_coding":"AJCC IV C & D",
        "Biopsy_site_tissue":"skin",
        "Progression-free survival event":"Y",
        "PFS_days":105.0,
        "PFS_days_clipped2000":105.0,
        "Progression-free survival days":"102-293 days (25%-50%)",
        "response":"NR",
        "FFPE Sample Type":null,
        "Study_Site":"POL",
        "ICI_cluster":"Ribo-high",
        "TERT":"mutant",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "ARID2":"wildtype"
    },
    "GR15":{
        "cohort":"validation",
        "sex":"Female",
        "age":48.0,
        "age_group":"<50.0 (25%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-C",
        "stage_coding":"AJCC IV C & D",
        "Biopsy_site_tissue":"skin",
        "Progression-free survival event":"N",
        "PFS_days":266.0,
        "PFS_days_clipped2000":266.0,
        "Progression-free survival days":"102-293 days (25%-50%)",
        "response":"R",
        "FFPE Sample Type":null,
        "Study_Site":"GE",
        "ICI_cluster":"Ribo-high",
        "TERT":"mutant",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "ARID2":"wildtype"
    },
    "CR01":{
        "cohort":"validation",
        "sex":"Male",
        "age":38.0,
        "age_group":"<50.0 (25%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-C",
        "stage_coding":"AJCC IV C & D",
        "Biopsy_site_tissue":"skin",
        "Progression-free survival event":"N",
        "PFS_days":545.0,
        "PFS_days_clipped2000":545.0,
        "Progression-free survival days":"293-1604 days (50%-75%)",
        "response":"R",
        "FFPE Sample Type":null,
        "Study_Site":"POL",
        "ICI_cluster":"Ribo-high",
        "TERT":"mutant",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "ARID2":"wildtype"
    },
    "GR01":{
        "cohort":"validation",
        "sex":"Male",
        "age":56.0,
        "age_group":"50.0-58.0 (25%-50%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-A",
        "stage_coding":"else",
        "Biopsy_site_tissue":"skin",
        "Progression-free survival event":"Y",
        "PFS_days":41.0,
        "PFS_days_clipped2000":41.0,
        "Progression-free survival days":"<102 days (25%)",
        "response":"NR",
        "FFPE Sample Type":null,
        "Study_Site":"GE",
        "ICI_cluster":"Ribo-high",
        "TERT":"wildtype",
        "BRAF":"wildtype",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "ARID2":"wildtype"
    },
    "NY02":{
        "cohort":"validation",
        "sex":"Male",
        "age":63.0,
        "age_group":"58.0-68.0 (50%-75%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-B",
        "stage_coding":"else",
        "Biopsy_site_tissue":"skin",
        "Progression-free survival event":"Y",
        "PFS_days":57.0,
        "PFS_days_clipped2000":57.0,
        "Progression-free survival days":"<102 days (25%)",
        "response":"NR",
        "FFPE Sample Type":null,
        "Study_Site":"NY",
        "ICI_cluster":"EMT-like",
        "TERT":"mutant",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"mutant",
        "ARID2":"wildtype"
    },
    "GR05":{
        "cohort":"validation",
        "sex":"Female",
        "age":53.0,
        "age_group":"50.0-58.0 (25%-50%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-C",
        "stage_coding":"AJCC IV C & D",
        "Biopsy_site_tissue":"skin",
        "Progression-free survival event":"Y",
        "PFS_days":58.0,
        "PFS_days_clipped2000":58.0,
        "Progression-free survival days":"<102 days (25%)",
        "response":"NR",
        "FFPE Sample Type":null,
        "Study_Site":"GE",
        "ICI_cluster":"EMT-like",
        "TERT":"mutant",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"mutant",
        "ARID2":"mutant"
    },
    "MD14":{
        "cohort":"validation",
        "sex":"Male",
        "age":73.8288843258,
        "age_group":">68.0 (>75%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-C",
        "stage_coding":"AJCC IV C & D",
        "Biopsy_site_tissue":"skin",
        "Progression-free survival event":"N",
        "PFS_days":2727.0,
        "PFS_days_clipped2000":2001.0,
        "Progression-free survival days":">1604 days (>75%)",
        "response":"R",
        "FFPE Sample Type":null,
        "Study_Site":"MDACC",
        "ICI_cluster":"ICI-sensitive",
        "TERT":"mutant",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"mutant",
        "ARID2":"wildtype"
    },
    "MI02":{
        "cohort":"validation",
        "sex":"Male",
        "age":53.0,
        "age_group":"50.0-58.0 (25%-50%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-B",
        "stage_coding":"else",
        "Biopsy_site_tissue":"LN",
        "Progression-free survival event":"N",
        "PFS_days":1370.0,
        "PFS_days_clipped2000":1370.0,
        "Progression-free survival days":"293-1604 days (50%-75%)",
        "response":"R",
        "FFPE Sample Type":null,
        "Study_Site":"UM",
        "ICI_cluster":"Ribo-high",
        "TERT":"wildtype",
        "BRAF":"wildtype",
        "NRAS":"mutant",
        "NF1":"wildtype",
        "ARID2":"wildtype"
    },
    "NY07":{
        "cohort":"validation",
        "sex":"Female",
        "age":38.0,
        "age_group":"<50.0 (25%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-A",
        "stage_coding":"else",
        "Biopsy_site_tissue":"skin",
        "Progression-free survival event":"Y",
        "PFS_days":257.0,
        "PFS_days_clipped2000":257.0,
        "Progression-free survival days":"102-293 days (25%-50%)",
        "response":"R",
        "FFPE Sample Type":null,
        "Study_Site":"NY",
        "ICI_cluster":"Ribo-high",
        "TERT":"mutant",
        "BRAF":"wildtype",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "ARID2":"wildtype"
    },
    "NY06":{
        "cohort":"validation",
        "sex":"Female",
        "age":42.0,
        "age_group":"<50.0 (25%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-D",
        "stage_coding":"AJCC IV C & D",
        "Biopsy_site_tissue":"LN",
        "Progression-free survival event":"Y",
        "PFS_days":371.0,
        "PFS_days_clipped2000":371.0,
        "Progression-free survival days":"293-1604 days (50%-75%)",
        "response":"R",
        "FFPE Sample Type":null,
        "Study_Site":"NY",
        "ICI_cluster":"EMT-like",
        "TERT":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "ARID2":"wildtype"
    },
    "SK05":{
        "cohort":"validation",
        "sex":"Male",
        "age":78.0,
        "age_group":">68.0 (>75%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-A",
        "stage_coding":"else",
        "Biopsy_site_tissue":"skin",
        "Progression-free survival event":"Y",
        "PFS_days":45.0,
        "PFS_days_clipped2000":45.0,
        "Progression-free survival days":"<102 days (25%)",
        "response":"NR",
        "FFPE Sample Type":null,
        "Study_Site":"MSK",
        "ICI_cluster":"EMT-like",
        "TERT":null,
        "BRAF":null,
        "NRAS":null,
        "NF1":null,
        "ARID2":null
    },
    "CR20":{
        "cohort":"validation",
        "sex":"Male",
        "age":70.0,
        "age_group":">68.0 (>75%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-A",
        "stage_coding":"else",
        "Biopsy_site_tissue":"LN",
        "Progression-free survival event":"Y",
        "PFS_days":91.0,
        "PFS_days_clipped2000":91.0,
        "Progression-free survival days":"<102 days (25%)",
        "response":"NR",
        "FFPE Sample Type":null,
        "Study_Site":"POL",
        "ICI_cluster":"ICI-sensitive",
        "TERT":"wildtype",
        "BRAF":"wildtype",
        "NRAS":"mutant",
        "NF1":"wildtype",
        "ARID2":"wildtype"
    },
    "CR09":{
        "cohort":"validation",
        "sex":"Male",
        "age":29.0,
        "age_group":"<50.0 (25%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-D",
        "stage_coding":"AJCC IV C & D",
        "Biopsy_site_tissue":"skin",
        "Progression-free survival event":"Y",
        "PFS_days":355.0,
        "PFS_days_clipped2000":355.0,
        "Progression-free survival days":"293-1604 days (50%-75%)",
        "response":"R",
        "FFPE Sample Type":null,
        "Study_Site":"POL",
        "ICI_cluster":"Ribo-high",
        "TERT":"mutant",
        "BRAF":"wildtype",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "ARID2":"wildtype"
    },
    "MA22":{
        "cohort":"validation",
        "sex":"Male",
        "age":57.0,
        "age_group":"50.0-58.0 (25%-50%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-D",
        "stage_coding":"AJCC IV C & D",
        "Biopsy_site_tissue":"skin",
        "Progression-free survival event":"Y",
        "PFS_days":512.0,
        "PFS_days_clipped2000":512.0,
        "Progression-free survival days":"293-1604 days (50%-75%)",
        "response":"R",
        "FFPE Sample Type":null,
        "Study_Site":"MIA",
        "ICI_cluster":"EMT-like",
        "TERT":null,
        "BRAF":null,
        "NRAS":null,
        "NF1":null,
        "ARID2":null
    },
    "GR23":{
        "cohort":"validation",
        "sex":"Male",
        "age":59.0,
        "age_group":"58.0-68.0 (50%-75%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-B",
        "stage_coding":"else",
        "Biopsy_site_tissue":"LN",
        "Progression-free survival event":"Y",
        "PFS_days":190.0,
        "PFS_days_clipped2000":190.0,
        "Progression-free survival days":"102-293 days (25%-50%)",
        "response":"R",
        "FFPE Sample Type":null,
        "Study_Site":"GE",
        "ICI_cluster":"ICI-sensitive",
        "TERT":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "ARID2":"wildtype"
    },
    "GR09":{
        "cohort":"validation",
        "sex":"Female",
        "age":76.0,
        "age_group":">68.0 (>75%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-D",
        "stage_coding":"AJCC IV C & D",
        "Biopsy_site_tissue":"LN",
        "Progression-free survival event":"N",
        "PFS_days":871.0,
        "PFS_days_clipped2000":871.0,
        "Progression-free survival days":"293-1604 days (50%-75%)",
        "response":"R",
        "FFPE Sample Type":null,
        "Study_Site":"GE",
        "ICI_cluster":"ICI-sensitive",
        "TERT":"mutant",
        "BRAF":"wildtype",
        "NRAS":"mutant",
        "NF1":"wildtype",
        "ARID2":"wildtype"
    },
    "GR04":{
        "cohort":"validation",
        "sex":"Female",
        "age":50.0,
        "age_group":"50.0-58.0 (25%-50%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-D",
        "stage_coding":"AJCC IV C & D",
        "Biopsy_site_tissue":"skin",
        "Progression-free survival event":"Y",
        "PFS_days":98.0,
        "PFS_days_clipped2000":98.0,
        "Progression-free survival days":"<102 days (25%)",
        "response":"NR",
        "FFPE Sample Type":null,
        "Study_Site":"GE",
        "ICI_cluster":"EMT-like",
        "TERT":"mutant",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "ARID2":"wildtype"
    },
    "MD15":{
        "cohort":"validation",
        "sex":"Female",
        "age":34.803559206,
        "age_group":"<50.0 (25%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-B",
        "stage_coding":"else",
        "Biopsy_site_tissue":"skin",
        "Progression-free survival event":"Y",
        "PFS_days":373.0,
        "PFS_days_clipped2000":373.0,
        "Progression-free survival days":"293-1604 days (50%-75%)",
        "response":"R",
        "FFPE Sample Type":null,
        "Study_Site":"MDACC",
        "ICI_cluster":"EMT-like",
        "TERT":"mutant",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "ARID2":"wildtype"
    },
    "MI04":{
        "cohort":"validation",
        "sex":"Male",
        "age":69.0,
        "age_group":">68.0 (>75%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-B",
        "stage_coding":"else",
        "Biopsy_site_tissue":"skin",
        "Progression-free survival event":"N",
        "PFS_days":1757.0,
        "PFS_days_clipped2000":1757.0,
        "Progression-free survival days":">1604 days (>75%)",
        "response":"R",
        "FFPE Sample Type":null,
        "Study_Site":"UM",
        "ICI_cluster":"ICI-sensitive",
        "TERT":"mutant",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "ARID2":"wildtype"
    },
    "MA21":{
        "cohort":"validation",
        "sex":"Male",
        "age":70.0,
        "age_group":">68.0 (>75%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-B",
        "stage_coding":"else",
        "Biopsy_site_tissue":"skin",
        "Progression-free survival event":"N",
        "PFS_days":3140.0,
        "PFS_days_clipped2000":2001.0,
        "Progression-free survival days":">1604 days (>75%)",
        "response":"R",
        "FFPE Sample Type":null,
        "Study_Site":"MIA",
        "ICI_cluster":"ICI-sensitive",
        "TERT":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "ARID2":"wildtype"
    },
    "CR19":{
        "cohort":"validation",
        "sex":"Male",
        "age":55.0,
        "age_group":"50.0-58.0 (25%-50%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-C",
        "stage_coding":"AJCC IV C & D",
        "Biopsy_site_tissue":"LN",
        "Progression-free survival event":"N",
        "PFS_days":648.0,
        "PFS_days_clipped2000":648.0,
        "Progression-free survival days":"293-1604 days (50%-75%)",
        "response":"R",
        "FFPE Sample Type":null,
        "Study_Site":"POL",
        "ICI_cluster":"Ribo-high",
        "TERT":"mutant",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "ARID2":"wildtype"
    },
    "GR07":{
        "cohort":"validation",
        "sex":"Male",
        "age":64.0,
        "age_group":"58.0-68.0 (50%-75%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-C",
        "stage_coding":"AJCC IV C & D",
        "Biopsy_site_tissue":"skin",
        "Progression-free survival event":"N",
        "PFS_days":2382.0,
        "PFS_days_clipped2000":2001.0,
        "Progression-free survival days":">1604 days (>75%)",
        "response":"R",
        "FFPE Sample Type":null,
        "Study_Site":"GE",
        "ICI_cluster":"Ribo-high",
        "TERT":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "ARID2":"wildtype"
    },
    "NY11":{
        "cohort":"validation",
        "sex":"Female",
        "age":67.0,
        "age_group":"58.0-68.0 (50%-75%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-B",
        "stage_coding":"else",
        "Biopsy_site_tissue":"lung",
        "Progression-free survival event":"Y",
        "PFS_days":126.0,
        "PFS_days_clipped2000":126.0,
        "Progression-free survival days":"102-293 days (25%-50%)",
        "response":"NR",
        "FFPE Sample Type":null,
        "Study_Site":"NY",
        "ICI_cluster":"EMT-like",
        "TERT":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "ARID2":"wildtype"
    },
    "GR24":{
        "cohort":"validation",
        "sex":"Male",
        "age":50.0,
        "age_group":"50.0-58.0 (25%-50%)",
        "ethnicity":"Caucasian",
        "AJCC Stage":"AJCC IV-B",
        "stage_coding":"else",
        "Biopsy_site_tissue":"lung",
        "Progression-free survival event":"Y",
        "PFS_days":106.0,
        "PFS_days_clipped2000":106.0,
        "Progression-free survival days":"102-293 days (25%-50%)",
        "response":"NR",
        "FFPE Sample Type":null,
        "Study_Site":"GE",
        "ICI_cluster":"ICI-sensitive",
        "TERT":"mutant",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "ARID2":"wildtype"
    }
}